var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _path6, _path7, _rect3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect4, _rect5, _rect6, _rect7, _rect8, _path15, _path16, _rect9, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _rect10, _path31, _path32, _path33, _path34, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _circle2, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _circle3, _rect33, _rect34, _rect35, _rect36, _path35, _path36, _mask, _path37, _circle4, _circle5, _circle6, _rect37, _path38, _mask2, _path39, _circle7, _circle8, _circle9, _path40, _circle10, _rect38, _path41, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _ellipse, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _rect47, _g, _rect48, _rect49, _path210, _rect50, _path211, _rect51, _path212, _path213, _path214, _ellipse2, _path215, _ellipse3, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _rect52, _path236, _rect53, _g2, _rect54, _circle11, _circle12, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _ellipse4, _ellipse5, _line, _rect55, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _circle13, _circle14, _g3, _path264, _path265, _path266, _rect56, _ellipse6, _ellipse7, _ellipse8, _path267, _ellipse9, _ellipse10, _circle15, _circle16, _circle17, _circle18, _circle19, _path268, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _circle20, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _ellipse22, _ellipse23, _rect57, _g4, _path317, _ellipse24, _g5, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHaunted = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 800,
    viewBox: "0 0 1200 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3713_15982)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.00012207H1200V800H0V0.00012207Z",
    fill: "#0B0F21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122 251H1V799H881V496H816V417L370 407L122 251Z",
    fill: "#242941",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 665H1198V800H0V665Z",
    fill: "#5A212C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M622 418H664V666L622 674V418Z",
    fill: "#313856"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M381 413.5H424V674L381 666.5V413.5Z",
    fill: "#181C2E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 157,
    width: 131,
    height: 118,
    fill: "#5D5E93"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131 157L381 318V433L131 275V157Z",
    fill: "#5D5E93"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.5 799L1045.5 0.00012207",
    stroke: "#5D5E93",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 301,
    width: 197,
    height: 127,
    fill: "#5D5E93"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M381 318L424 301V428L381 433.5V318Z",
    fill: "#515288"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M664 318L621 301V428L664 435.5V318Z",
    fill: "#7172AE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M664 318L825 402V519.5L664 435.5V318Z",
    fill: "#5D5E93"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M827.024 463H1044.17L1198 564.079V798H973.228L827.024 510.022V463Z",
    fill: "#0B0F21",
    stroke: "black",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M775 461H1046",
    stroke: "#5D5E93",
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M825 402L995.5 579.5V800H980H968.5L952.875 768.875L910.25 685.75L825 519.5V402Z",
    fill: "#4A4B7B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M825 519.5V668.5L901.5 740.75L939.75 776.875L958.875 794.938L964 800H971L968.438 794.656L958.875 776.313L939.75 739.625L901.5 666.25L825 519.5Z",
    fill: "#0B0F21"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 29.0001,
    width: 113,
    height: 67,
    fill: "#AF8C6B",
    stroke: "#2A2C51",
    strokeWidth: 6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 31.0001,
    width: 144,
    height: 151,
    fill: "#B09799",
    stroke: "#2A2C51",
    strokeWidth: 10
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 546,
    y: 114,
    width: 113,
    height: 81,
    fill: "#B67F68",
    stroke: "#2A2C51",
    strokeWidth: 6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 723.455,
    y: 25.4556,
    width: 154.089,
    height: 161.089,
    fill: "#B09799",
    stroke: "#2A2C51",
    strokeWidth: 8.91089
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 23.0001,
    width: 83,
    height: 99,
    fill: "#B47D4A",
    stroke: "#2A2C51",
    strokeWidth: 4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33 739H301.679V420.5L151.085 324H33V739Z",
    fill: "#454675"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M280 435.219V717.5H55V347.5H141.063L280 435.219Z",
    fill: "#0B0F21",
    stroke: "black",
    strokeWidth: 3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 453.584,
    width: 224.268,
    height: 6.81779,
    fill: "#454675",
    stroke: "black",
    strokeWidth: 3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55 540.5H279V547.875H55V540.5Z",
    fill: "#454675",
    stroke: "black",
    strokeWidth: 3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55 622.5H279V629.5H55V622.5Z",
    fill: "#454675",
    stroke: "black",
    strokeWidth: 3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.798 497.364C241.902 496.957 241.958 496.531 241.958 496.091C241.958 493.28 239.679 491 236.867 491C234.055 491 231.775 493.28 231.775 496.091C231.775 496.531 231.831 496.957 231.936 497.364H224.138C217.109 497.364 211.41 503.063 211.41 510.093V539.368H205.682C203.925 539.368 202.5 540.793 202.5 542.55C202.5 544.308 203.925 545.732 205.682 545.732H270.597C272.354 545.732 273.779 544.308 273.779 542.55C273.779 540.793 272.354 539.368 270.597 539.368H263.596V510.093C263.596 503.063 257.898 497.364 250.868 497.364H241.798Z",
    fill: "#454675"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M224.775 501.819C220.956 501.819 216.502 503.729 215.865 508.82M237.504 493.546C236.231 492.909 233.685 494.182 234.321 496.091",
    stroke: "#666899",
    strokeWidth: 2.54568,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M224.139 524.276C224.139 527.33 229.654 530.64 232.412 531.913L236.867 526.821C236.083 532.701 233.127 534.557 230.674 535.363C229.543 535.734 229.646 536.367 230.836 536.367H253.414C254.05 535.519 255.323 533.185 255.323 530.64C255.323 527.458 252.778 527.458 252.141 524.276C251.505 521.093 235.594 515.366 232.412 516.638C229.23 517.911 224.139 520.457 224.139 524.276Z",
    fill: "#D38337"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M232.412 531.913L231.879 533.068L232.743 533.467L233.37 532.751L232.412 531.913ZM253.414 536.367V537.64H254.05L254.432 537.131L253.414 536.367ZM230.674 535.363L230.276 534.154H230.276L230.674 535.363ZM236.867 526.821L238.129 526.989L238.686 522.809L235.909 525.983L236.867 526.821ZM232.946 530.757C231.632 530.151 229.657 529.055 228.033 527.765C227.22 527.12 226.538 526.46 226.068 525.823C225.59 525.175 225.412 524.659 225.412 524.276H222.866C222.866 525.419 223.376 526.462 224.019 527.334C224.67 528.217 225.539 529.036 226.45 529.759C228.273 531.206 230.435 532.402 231.879 533.068L232.946 530.757ZM225.412 524.276C225.412 522.97 226.287 521.708 227.854 520.515C229.387 519.347 231.329 518.443 232.885 517.82L231.939 515.457C230.313 516.107 228.119 517.112 226.311 518.49C224.536 519.842 222.866 521.762 222.866 524.276H225.412ZM232.885 517.82C233.016 517.768 233.382 517.703 234.077 517.742C234.732 517.778 235.55 517.897 236.487 518.093C238.359 518.485 240.603 519.16 242.784 519.978C244.969 520.797 247.043 521.742 248.59 522.656C249.365 523.115 249.97 523.544 250.383 523.921C250.835 524.334 250.896 524.54 250.893 524.525L253.389 524.026C253.227 523.215 252.652 522.546 252.1 522.042C251.508 521.501 250.74 520.971 249.885 520.465C248.17 519.45 245.948 518.446 243.678 517.595C241.405 516.742 239.035 516.025 237.008 515.601C235.997 515.39 235.044 515.246 234.218 515.2C233.431 515.156 232.604 515.191 231.939 515.457L232.885 517.82ZM250.893 524.525C251.288 526.5 252.325 527.531 253.025 528.309C253.375 528.699 253.611 528.988 253.777 529.32C253.931 529.628 254.05 530.028 254.05 530.64H256.596C256.596 529.66 256.397 528.867 256.054 528.181C255.723 527.518 255.282 527.012 254.917 526.606C254.185 525.793 253.631 525.233 253.389 524.026L250.893 524.525ZM254.05 530.64C254.05 532.821 252.93 534.892 252.396 535.604L254.432 537.131C255.171 536.146 256.596 533.55 256.596 530.64H254.05ZM253.414 535.095H230.836V537.64H253.414V535.095ZM231.071 536.572C232.433 536.124 234.011 535.359 235.352 533.835C236.695 532.309 237.711 530.124 238.129 526.989L235.605 526.653C235.24 529.397 234.385 531.08 233.441 532.154C232.494 533.229 231.368 533.795 230.276 534.154L231.071 536.572ZM233.37 532.751L237.825 527.659L235.909 525.983L231.454 531.074L233.37 532.751ZM230.836 535.095C230.632 535.095 230.583 535.065 230.631 535.085C230.641 535.088 231.053 535.258 231.141 535.8C231.229 536.344 230.89 536.637 230.881 536.645C230.841 536.679 230.877 536.636 231.071 536.572L230.276 534.154C229.905 534.276 229.53 534.451 229.228 534.708C228.957 534.94 228.507 535.46 228.628 536.209C228.749 536.955 229.34 537.307 229.668 537.441C230.035 537.591 230.445 537.64 230.836 537.64V535.095Z",
    fill: "#D38337"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M233.682 533.706C230.924 532.434 224.139 527.33 224.139 524.276C224.139 520.457 229.23 517.911 232.412 516.638C235.594 515.366 251.505 521.093 252.141 524.276C252.778 527.458 255.323 527.458 255.323 530.64C255.323 533.185 254.05 535.519 253.414 536.367H242.595M236.867 526.821C236.083 532.701 233.127 534.557 230.674 535.363C229.543 535.734 229.646 536.367 230.836 536.367H242.595M247.05 529.185C243.656 528.246 238.013 528.366 242.595 536.367",
    stroke: "#0B0F21",
    strokeWidth: 2.54568,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 233.685,
    cy: 522.185,
    r: 1.90926,
    fill: "#0B0F21"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 681.5C221.5 683.433 215.232 685 207.5 685C199.768 685 193.5 683.433 193.5 681.5C193.5 679.567 199.768 678 207.5 678C215.232 678 221.5 679.567 221.5 681.5Z",
    fill: "#B09799"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M204.5 672C206.1 675.2 204.833 681.667 204 684.5C206.5 682 206.5 672.5 207 670C207.5 667.5 211 663.5 212 661C213 658.5 210 655 209 649.5C208.2 645.1 210.666 637.333 212 634C208.5 635.5 200.5 646.5 199.5 653.5C198.5 660.5 202.5 668 204.5 672Z",
    fill: "#D38337",
    stroke: "#C66238",
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M205.5 665.5C203.1 668.7 203.167 679.833 203.5 685C203.5 684 209.5 672.5 212 672C214.5 671.5 217.5 665.5 218 662C218.5 658.5 222 655.5 222.5 654C223 652.5 218.5 656 216.5 657.5C214.5 659 208.5 661.5 205.5 665.5Z",
    fill: "#D38337",
    stroke: "#C66238",
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M217.5 675.5C214.7 677.9 213.333 681.5 213 683C212 680 212 677 213 672.5C214 668 217.5 665 220 661.5C222.5 658 233 653.5 233 654C233 654.5 228.5 660.5 226.5 662.5C224.5 664.5 224.5 668.5 223 670.5C221.5 672.5 221 672.5 217.5 675.5Z",
    fill: "#D38337",
    stroke: "#C66238",
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M205.5 685.5C205.5 680.667 207.6 670.4 216 668C220 669.2 223.667 667.5 225 666.5C226.2 668.9 223.5 673.833 222 676C220.252 675.418 218.905 674.026 217.925 672.5C214.283 673.833 206.7 678.3 205.5 685.5Z",
    fill: "#D38337"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M216 668C207.6 670.4 205.5 680.667 205.5 685.5C206.7 678.3 214.283 673.833 217.925 672.5M216 668C220 669.2 223.667 667.5 225 666.5C226.2 668.9 223.5 673.833 222 676C220.252 675.418 218.905 674.026 217.925 672.5M216 668C216.257 669.115 216.885 670.883 217.925 672.5",
    stroke: "#C66238",
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M201.5 685C201.5 684.832 201.331 684.327 201.163 683.616C199.6 679.561 193.18 670.959 194.5 667C195.7 663.4 193.667 656.167 192.5 653C196 656 196 660.5 196.5 662C197 663.5 202.5 668.5 203 670.5C203.5 672.5 203 675 201.5 678C200.503 679.994 200.831 682.208 201.163 683.616C201.377 684.17 201.5 684.639 201.5 685Z",
    fill: "#D38337",
    stroke: "#C66238",
    strokeLinecap: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 179.5,
    y: 705,
    width: 57,
    height: 10,
    fill: "#732F3B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M186.525 695.5C186.125 690.7 190.691 683.5 193.025 680.5C195.025 680.5 202.119 683.014 207.525 682C215.525 680.5 218.858 680 221.025 679C222.691 681.5 224.825 685.7 226.025 688.5C227.525 692 230.025 697.5 228.025 700C226.025 702.5 225.025 701.5 222.525 701.5C220.525 701.5 220.691 706.833 221.025 709.5C219.858 710.667 215.525 713 207.525 713C199.525 713 194.525 709.667 193.025 708V701.5C193.025 700 187.025 701.5 186.525 695.5Z",
    fill: "#E8E0D4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M192.519 689C194.119 687 199.186 687.167 201.519 687.5C203.019 688 205.919 689.5 205.519 691.5C205.019 694 201.519 694 200.019 695C198.519 696 198.519 699.5 195.019 699C191.519 698.5 190.519 691.5 192.519 689Z",
    fill: "#0B0F21"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M218.519 697.5C216.519 698 209.519 695 210.019 689C210.686 688 212.519 686 214.519 686C217.019 686 220.019 686 220.519 689C221.019 692 220.519 697 218.519 697.5Z",
    fill: "#0B0F21"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M206.955 702.433C205.679 703.071 204.296 702.167 203.764 701.635C201.371 700.623 202.966 707.22 203.764 707.619C204.562 708.018 206.157 706.023 207.753 705.624C209.349 705.226 209.748 706.821 211.742 706.023C213.737 705.226 211.343 700.439 209.748 699.242C208.152 698.045 208.551 701.635 206.955 702.433Z",
    fill: "#0B0F21"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 715,
    width: 6,
    height: 69,
    transform: "rotate(90 242.5 715)",
    fill: "#B09799"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 81.5,
    y: 657,
    width: 11,
    height: 62,
    fill: "#D38337"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 669,
    width: 11,
    height: 50,
    fill: "#B09799"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 650,
    width: 24,
    height: 69,
    fill: "#732F3B"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 667,
    width: 24,
    height: 3,
    fill: "#4B1821"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 702,
    width: 24,
    height: 3,
    fill: "#4B1821"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 689,
    width: 22,
    height: 2,
    fill: "#4B1821"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 681,
    width: 22,
    height: 2,
    fill: "#4B1821"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.5,
    cy: 686,
    r: 2,
    fill: "#4B1821"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    y: 674,
    width: 3,
    height: 32,
    fill: "#935317"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 96.5,
    y: 683,
    width: 3,
    height: 26,
    fill: "#856E6F"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 103.509,
    y: 673.727,
    width: 10.9534,
    height: 46,
    transform: "rotate(-8.87505 103.509 673.727)",
    fill: "#C66238"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 110.312,
    y: 710.672,
    width: 3,
    height: 9,
    transform: "rotate(-98.5688 110.312 710.672)",
    fill: "#8E4221"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 717,
    width: 42,
    height: 2,
    fill: "#926F72"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 242.145,
    y: 566,
    width: 18,
    height: 58,
    fill: "#732F3B"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 260.145,
    y: 555,
    width: 17,
    height: 69,
    fill: "#C66238"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 262.145,
    y: 573,
    width: 13,
    height: 3,
    fill: "#924323"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 262.145,
    y: 605,
    width: 13,
    height: 3,
    fill: "#924323"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 266.145,
    y: 581,
    width: 5,
    height: 20,
    fill: "#924323"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 243.145,
    y: 581,
    width: 16,
    height: 2,
    fill: "#531C25"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 243.145,
    y: 598,
    width: 16,
    height: 2,
    fill: "#531C25"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 243.145,
    y: 602,
    width: 16,
    height: 2,
    fill: "#531C25"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 230.214,
    y: 573.013,
    width: 12,
    height: 50,
    transform: "rotate(11.203 230.214 573.013)",
    fill: "#B09799"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 229.339,
    cy: 607.804,
    r: 3,
    transform: "rotate(11.203 229.339 607.804)",
    fill: "#8E7174"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 227.165,
    y: 598.198,
    width: 8,
    height: 2,
    transform: "rotate(11.203 227.165 598.198)",
    fill: "#8C7476"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 224.25,
    y: 612.912,
    width: 8,
    height: 2,
    transform: "rotate(11.203 224.25 612.912)",
    fill: "#8C7476"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 92.166,
    y: 601.667,
    width: 20,
    height: 21.3333,
    fill: "#732F3B"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 70.833,
    y: 575,
    width: 16,
    height: 48,
    fill: "#454675"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M100.487 583H104.314L103.358 589.123H101.444L100.487 583Z",
    fill: "#D38337"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M76.166 555H81.4993L80.8327 561.667H76.8327L76.166 555Z",
    fill: "#454675"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-74-inside-1_3713_15982",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1906 586.062C98.1906 585.639 98.5333 585.296 98.956 585.296H105.845C106.268 585.296 106.61 585.639 106.61 586.062V586.827C106.61 587.25 106.268 587.593 105.845 587.593V590.396C110.082 591.683 113.199 595.279 113.479 599.588C113.492 599.67 113.499 599.754 113.499 599.84V600.222V622.803C113.499 623.648 112.814 624.333 111.968 624.333H92.8326C91.9872 624.333 91.3018 623.648 91.3018 622.803V600.222V599.84C91.3018 599.754 91.3088 599.67 91.3223 599.588C91.6025 595.279 94.7189 591.683 98.9561 590.396V587.593H98.956C98.5333 587.593 98.1906 587.25 98.1906 586.827V586.062Z"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M105.845 587.593L105.845 586.259L104.512 586.259V587.593H105.845ZM105.845 590.396H104.512V591.385L105.458 591.672L105.845 590.396ZM113.479 599.588L112.148 599.675L112.152 599.74L112.163 599.805L113.479 599.588ZM91.3223 599.588L92.6378 599.805L92.6486 599.74L92.6528 599.675L91.3223 599.588ZM98.9561 590.396L99.3435 591.672L100.289 591.385V590.396H98.9561ZM98.9561 587.593H100.289V586.259H98.9561V587.593ZM98.956 583.963C97.7969 583.963 96.8573 584.903 96.8573 586.062H99.5239C99.5239 586.375 99.2697 586.63 98.956 586.63V583.963ZM105.845 583.963H98.956V586.63H105.845V583.963ZM107.944 586.062C107.944 584.903 107.004 583.963 105.845 583.963V586.63C105.531 586.63 105.277 586.375 105.277 586.062H107.944ZM107.944 586.827V586.062H105.277V586.827H107.944ZM105.845 588.926C107.004 588.926 107.944 587.986 107.944 586.827H105.277C105.277 586.514 105.531 586.259 105.845 586.259L105.845 588.926ZM107.178 590.396V587.593H104.512V590.396H107.178ZM114.809 599.502C114.489 594.578 110.941 590.55 106.232 589.12L105.458 591.672C109.224 592.816 111.908 595.98 112.148 599.675L114.809 599.502ZM112.163 599.805C112.165 599.816 112.166 599.827 112.166 599.84H114.833C114.833 599.681 114.82 599.524 114.794 599.371L112.163 599.805ZM112.166 599.84V600.222H114.833V599.84H112.166ZM112.166 600.222V622.803H114.833V600.222H112.166ZM112.166 622.803C112.166 622.912 112.078 623 111.968 623V625.667C113.55 625.667 114.833 624.384 114.833 622.803H112.166ZM111.968 623H92.8326V625.667H111.968V623ZM92.8326 623C92.7235 623 92.6351 622.912 92.6351 622.803H89.9684C89.9684 624.384 91.2508 625.667 92.8326 625.667V623ZM92.6351 622.803V600.222H89.9684V622.803H92.6351ZM92.6351 600.222V599.84H89.9684V600.222H92.6351ZM92.6351 599.84C92.6351 599.827 92.6361 599.816 92.6378 599.805L90.0068 599.371C89.9815 599.524 89.9684 599.681 89.9684 599.84H92.6351ZM98.5686 589.12C93.8604 590.55 90.312 594.578 89.9918 599.502L92.6528 599.675C92.8931 595.98 95.5773 592.816 99.3435 591.672L98.5686 589.12ZM97.6227 587.593V590.396H100.289V587.593H97.6227ZM98.956 588.926H98.9561V586.259H98.956V588.926ZM96.8573 586.827C96.8573 587.986 97.7969 588.926 98.956 588.926V586.259C99.2697 586.259 99.5239 586.514 99.5239 586.827H96.8573ZM96.8573 586.062V586.827H99.5239V586.062H96.8573Z",
    fill: "#B09799",
    mask: "url(#path-74-inside-1_3713_15982)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.2771,
    cy: 604.049,
    r: 1.14815,
    fill: "#BC6F7D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.9568,
    cy: 602.136,
    r: 0.765432,
    fill: "#BC6F7D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.105,
    cy: 606.346,
    r: 1.91358,
    fill: "#BC6F7D"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 95.1289,
    y: 609.79,
    width: 14.5432,
    height: 5.35803,
    fill: "#B09799"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6602 613.305C97.1858 612.462 97.8025 611.646 98.4169 610.865C98.477 610.789 98.7608 610.359 98.8023 610.663C98.8846 611.266 98.6915 611.941 98.6535 612.545C98.6357 612.826 98.6461 613.102 98.7013 613.379C98.7162 613.454 98.7842 613.894 98.9086 613.927C99.0128 613.954 99.4002 613.214 99.4375 613.156C99.4979 613.062 100.163 611.992 100.2 612.029C100.322 612.151 100.326 612.651 100.365 612.813C100.614 613.852 101.717 612.739 102.087 612.338C102.157 612.262 102.257 612.036 102.34 612.144C102.595 612.477 102.954 612.547 103.358 612.603C103.784 612.663 104.192 612.593 104.615 612.593C104.728 612.593 104.936 612.778 105.064 612.816C105.638 612.984 106.23 613.084 106.818 613.185C107.093 613.233 107.39 613.151 107.663 613.114",
    stroke: "#0B0F21",
    strokeWidth: 0.765432,
    strokeLinecap: "round"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-81-inside-2_3713_15982",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2931 557.667C75.2931 556.93 75.8901 556.333 76.6265 556.333H81.0403C81.7766 556.333 82.3736 556.93 82.3736 557.667V559C82.3736 559.484 82.1157 559.908 81.7299 560.141V565.217C85.322 567.477 87.9563 573.825 88.1546 581.412C88.1626 581.496 88.1667 581.581 88.1667 581.667V582.333V621.667C88.1667 623.14 86.9728 624.333 85.5 624.333H72.1667C70.6939 624.333 69.5 623.14 69.5 621.667V582.333V581.667C69.5 581.581 69.5041 581.496 69.512 581.412C69.7104 573.825 72.3446 567.477 75.9368 565.217V560.141C75.551 559.908 75.2931 559.484 75.2931 559V557.667Z"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7299 560.141L81.0393 559.001L80.3965 559.39V560.141H81.7299ZM81.7299 565.217H80.3965V565.954L81.02 566.346L81.7299 565.217ZM88.1546 581.412L86.8218 581.447L86.823 581.492L86.8273 581.538L88.1546 581.412ZM69.512 581.412L70.8394 581.538L70.8437 581.492L70.8449 581.447L69.512 581.412ZM75.9368 565.217L76.6467 566.346L77.2701 565.954V565.217H75.9368ZM75.9368 560.141H77.2701V559.39L76.6274 559.001L75.9368 560.141ZM76.6265 555C75.1537 555 73.9598 556.194 73.9598 557.667H76.6265V557.667V555ZM81.0403 555H76.6265V557.667H81.0403V555ZM83.7069 557.667C83.7069 556.194 82.513 555 81.0403 555V557.667H81.0403H83.7069ZM83.7069 559V557.667H81.0403V559H83.7069ZM82.4205 561.282C83.1887 560.817 83.7069 559.97 83.7069 559H81.0403C81.0403 559.002 81.04 559.002 81.0404 559.001C81.0406 559 81.041 558.999 81.0411 558.999C81.0411 558.999 81.0409 558.999 81.0403 559C81.0401 559 81.0398 559.001 81.0396 559.001C81.0394 559.001 81.0393 559.001 81.0393 559.001L82.4205 561.282ZM83.0632 565.217V560.141H80.3965V565.217H83.0632ZM89.4875 581.377C89.3848 577.447 88.6512 573.803 87.4521 570.82C86.2637 567.862 84.5646 565.425 82.4398 564.088L81.02 566.346C82.4873 567.269 83.9015 569.135 84.9778 571.814C86.0435 574.466 86.7262 577.79 86.8218 581.447L89.4875 581.377ZM86.8273 581.538C86.8313 581.58 86.8333 581.623 86.8333 581.667H89.5C89.5 581.539 89.4939 581.412 89.482 581.286L86.8273 581.538ZM86.8333 581.667V582.333H89.5V581.667H86.8333ZM86.8333 582.333V621.667H89.5V582.333H86.8333ZM86.8333 621.667C86.8333 622.403 86.2364 623 85.5 623V625.667C87.7091 625.667 89.5 623.876 89.5 621.667H86.8333ZM85.5 623H72.1667V625.667H85.5V623ZM72.1667 623C71.4303 623 70.8333 622.403 70.8333 621.667H68.1667C68.1667 623.876 69.9575 625.667 72.1667 625.667V623ZM70.8333 621.667V582.333H68.1667V621.667H70.8333ZM70.8333 582.333V581.667H68.1667V582.333H70.8333ZM70.8333 581.667C70.8333 581.623 70.8354 581.58 70.8394 581.538L68.1846 581.286C68.1727 581.412 68.1667 581.539 68.1667 581.667H70.8333ZM75.2269 564.088C73.102 565.425 71.403 567.862 70.2145 570.82C69.0155 573.803 68.2819 577.447 68.1791 581.377L70.8449 581.447C70.9405 577.79 71.6232 574.466 72.6889 571.814C73.7652 569.136 75.1793 567.269 76.6467 566.346L75.2269 564.088ZM74.6034 560.141V565.217H77.2701V560.141H74.6034ZM73.9598 559C73.9598 559.97 74.478 560.817 75.2461 561.282L76.6274 559.001C76.6274 559.001 76.6273 559.001 76.6271 559.001C76.6269 559.001 76.6267 559 76.6264 559C76.6258 558.999 76.6256 558.999 76.6257 558.999C76.6257 558.999 76.6261 559 76.6264 559.001C76.6267 559.002 76.6265 559.002 76.6265 559H73.9598ZM73.9598 557.667V559H76.6265V557.667H73.9598Z",
    fill: "#B09799",
    mask: "url(#path-81-inside-2_3713_15982)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.4997,
    cy: 579.667,
    r: 0.666667,
    fill: "#C4C4C4"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 582.333,
    r: 2,
    fill: "#C4C4C4"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.1663,
    cy: 577.667,
    r: 1.33333,
    fill: "#C4C4C4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5003 591.667C81.5003 592.035 81.2018 592.333 80.8337 592.333C80.4655 592.333 80.167 592.035 80.167 591.667C80.167 591.299 80.4655 591 80.8337 591C81.2018 591 81.5003 591.299 81.5003 591.667Z",
    fill: "#C4C4C4"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.5003,
    cy: 593.667,
    r: 1.33333,
    fill: "#C4C4C4"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 72.167,
    y: 599,
    width: 13.3333,
    height: 5.33333,
    fill: "#B09799"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M74.375 602.25C74.4281 601.435 75.048 600.551 75.8472 600.285C75.9387 600.254 76.3241 600.138 76.3912 600.257C76.5067 600.462 76.3112 600.913 76.2454 601.104C76.1327 601.432 75.994 601.75 75.8796 602.077C75.7726 602.382 76.2064 602.022 76.2986 601.972C76.6884 601.762 77.2458 601.464 77.6968 601.637C77.9934 601.75 78.0143 601.983 78.0417 602.264C78.0894 602.753 78.561 602.582 78.9028 602.435C79.1131 602.345 79.6228 601.838 79.8611 601.968C80.3664 602.243 80.9488 602.157 81.4954 602.083C81.8252 602.039 82.0963 602.072 82.4167 602.125",
    stroke: "#0B0F21",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 386,
    width: 17,
    height: 69,
    fill: "#B09799"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 74.5,
    y: 398,
    width: 13,
    height: 57,
    fill: "#732F3B"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 402,
    width: 9,
    height: 35,
    fill: "#9B7073"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 414,
    width: 3,
    height: 35,
    fill: "#581924"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 542,
    width: 17,
    height: 101,
    transform: "rotate(-90 61.5 542)",
    fill: "#353665"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 70.2822,
    y: 525,
    width: 13,
    height: 83.4348,
    transform: "rotate(-90 70.2822 525)",
    fill: "#732F3B"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 536,
    width: 4,
    height: 46,
    transform: "rotate(-90 68.5 536)",
    fill: "#454675"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 83.5,
    y: 521,
    width: 4,
    height: 43,
    transform: "rotate(-90 83.5 521)",
    fill: "#581924"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M179.685 423.582C180.2 414.826 176.826 398.087 159.212 401.177C137.193 405.04 123.287 432.467 123.287 460.666C123.287 484.258 123.287 491.569 141.442 519.382C148.54 530.256 172.732 555.693 171.187 576.939C169.641 598.185 152.645 603.207 154.19 621.362C155.735 639.518 173.504 644.54 163.847 657.673C154.19 670.807 143.126 654.583 151.872 646.085",
    stroke: "#D38337",
    strokeWidth: 2.31773,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M188.569 407.744C191.273 407.229 196.527 404.113 195.909 395.769C192.947 396.8 187.333 400.637 188.569 407.744Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M174.232 394.393C175.546 391.974 176.462 385.935 169.614 381.129C168.535 384.073 167.949 390.848 174.232 394.393Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M151 460.064C150.873 462.813 152.684 468.647 160.943 469.984C160.629 466.864 158.201 460.512 151 460.064Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M148.613 453.266C145.866 453.08 139.995 454.764 138.48 462.992C141.606 462.746 148.009 460.455 148.613 453.266Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M143.065 480.096C141.373 482.267 139.483 488.076 145.454 493.936C146.999 491.208 148.684 484.62 143.065 480.096Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M120.849 507.779C118.625 506.157 112.76 504.453 107.092 510.607C109.868 512.065 116.506 513.54 120.849 507.779Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M132.592 490.656C130.743 488.617 125.347 485.756 118.547 490.631C120.969 492.622 127.169 495.415 132.592 490.656Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M114.634 519.748C112.003 518.939 105.902 519.235 102.545 526.899C105.645 527.374 112.402 526.609 114.634 519.748Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M115.565 534.07C112.89 534.718 107.797 538.091 108.828 546.394C111.735 545.218 117.152 541.107 115.565 534.07Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M122.175 546.47C119.713 547.702 115.507 552.131 118.374 559.991C120.943 558.193 125.3 552.972 122.175 546.47Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M136.11 584.006C137.212 581.483 137.607 575.388 130.372 571.186C129.55 574.212 129.546 581.012 136.11 584.006Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M121.689 541.489C123.276 543.738 128.285 547.233 135.627 543.221C133.464 540.95 127.65 537.425 121.689 541.489Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M116.481 524.978C116.107 527.705 117.386 533.678 125.492 535.752C125.459 532.617 123.612 526.072 116.481 524.978Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M131.1 552.47C132.062 555.049 136.017 559.704 144.138 557.693C142.625 554.946 137.899 550.057 131.1 552.47Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M142.688 566.376C143.65 568.955 147.605 573.611 155.726 571.599C154.213 568.853 149.487 563.963 142.688 566.376Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M141.658 583.597C139.612 585.437 136.731 590.823 141.58 597.642C143.58 595.227 146.396 589.037 141.658 583.597Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M132.397 586.523C129.719 585.889 123.651 586.589 120.808 594.458C123.932 594.727 130.624 593.516 132.397 586.523Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M124 578.861C122.59 576.496 117.864 572.626 110.236 576.063C112.217 578.493 117.744 582.455 124 578.861Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M123.283 569.261C122.707 566.57 119.473 561.388 111.146 562.193C112.242 565.131 116.205 570.657 123.283 569.261Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M121.059 511.812C120.279 514.451 120.643 520.549 128.343 523.82C128.784 520.716 127.944 513.968 121.059 511.812Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M129.158 497.865C127.467 500.037 125.576 505.845 131.547 511.706C133.093 508.977 134.778 502.389 129.158 497.865Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M144.79 473.426C142.46 471.961 136.492 470.663 131.259 477.192C134.129 478.455 140.853 479.471 144.79 473.426Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M149.522 443.786C150.197 446.454 153.621 451.512 161.913 450.398C160.708 447.503 156.543 442.128 149.522 443.786Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M137.529 449.464C140.233 448.949 145.487 445.832 144.869 437.489C141.907 438.519 136.293 442.356 137.529 449.464Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M143.659 426.115C144.528 428.727 148.313 433.521 156.501 431.803C155.088 429.004 150.541 423.948 143.659 426.115Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M132.121 432.467C134.825 431.952 140.079 428.836 139.461 420.492C136.499 421.522 130.885 425.359 132.121 432.467Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M140.67 411.396C141.095 414.116 144.035 419.47 152.395 419.129C151.464 416.135 147.815 410.396 140.67 411.396Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M182.672 404.828C180.661 402.948 175.047 400.542 168.672 405.96C171.25 407.745 177.659 410.017 182.672 404.828Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M150.233 395.859C148.173 397.684 145.252 403.049 150.05 409.903C152.068 407.503 154.93 401.335 150.233 395.859Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M141.705 400.243C139.435 398.686 133.523 397.151 128.034 403.465C130.851 404.843 137.529 406.126 141.705 400.243Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M157.045 390.891C158.109 388.232 158.384 381.94 150.977 378.044C150.207 381.205 150.342 388.198 157.045 390.891Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M190.501 423.554C190.243 416.472 185.556 399.991 171.959 395.355C154.962 389.561 148.782 394.196 144.146 399.604C139.511 405.013 137.579 417.76 144.146 430.894C150.713 444.028 151.486 459.479 149.941 465.66C148.395 471.841 136.034 486.52 131.012 494.245C125.991 501.971 112.471 515.491 116.333 531.329C120.196 547.167 136.42 556.824 141.442 568.027C147.237 580.954 139.125 585.41 133.716 585.41C128.092 585.41 124.446 579.229 124.059 574.207C123.673 569.185 123.287 569.572 123.287 569.572",
    stroke: "#D38337",
    strokeWidth: 2.31773,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M177.182 413.065C176.022 410.569 171.719 406.234 163.778 408.869C165.499 411.49 170.59 415.998 177.182 413.065Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M162.791 399.579C162.523 396.84 159.896 391.325 151.531 391.184C152.288 394.227 155.6 400.166 162.791 399.579Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M147.207 403.83C146.252 401.248 142.308 396.583 134.182 398.575C135.689 401.325 140.403 406.226 147.207 403.83Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M135.59 415.092C134.198 412.718 129.5 408.813 121.847 412.194C123.81 414.638 129.308 418.641 135.59 415.092Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M128.583 425.424C126.467 423.664 120.722 421.589 114.673 427.369C117.351 429.001 123.882 430.896 128.583 425.424Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M123.927 439.204C121.538 437.837 115.52 436.787 110.563 443.528C113.483 444.671 120.243 445.407 123.927 439.204Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M121.572 455.524C118.824 455.361 112.967 457.094 111.521 465.335C114.645 465.062 121.028 462.718 121.572 455.524Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M123.112 474.745C120.397 475.197 115.072 478.189 115.494 486.545C118.479 485.585 124.181 481.88 123.112 474.745Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M125.429 494.06C122.714 494.511 117.389 497.504 117.812 505.86C120.797 504.899 126.499 501.194 125.429 494.06Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M131.61 507.193C128.895 507.645 123.57 510.638 123.992 518.994C126.977 518.033 132.68 514.328 131.61 507.193Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M139.975 519.429C137.51 520.655 133.292 525.072 136.138 532.94C138.712 531.149 143.083 525.94 139.975 519.429Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M148.473 532.563C146.008 533.788 141.79 538.206 144.636 546.074C147.21 544.283 151.581 539.074 148.473 532.563Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M158.65 546.024C155.924 546.401 150.519 549.247 150.714 557.612C153.724 556.733 159.525 553.185 158.65 546.024Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M165.603 558.385C162.877 558.762 157.472 561.609 157.667 569.973C160.677 569.094 166.478 565.546 165.603 558.385Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M169.489 579.447C166.886 578.553 160.778 578.651 157.174 586.201C160.257 586.777 167.035 586.231 169.489 579.447Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M160.251 598.954C158.03 597.328 152.169 595.61 146.487 601.752C149.26 603.216 155.895 604.705 160.251 598.954Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M154.07 610.543C151.85 608.917 145.988 607.199 140.307 613.341C143.08 614.805 149.715 616.294 154.07 610.543Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M154.219 628.79C152.326 626.792 146.867 624.05 140.176 629.073C142.642 631.011 148.902 633.666 154.219 628.79Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M150.446 646.659C150.759 643.924 149.347 637.981 141.197 636.089C141.299 639.223 143.293 645.724 150.446 646.659Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M149.45 659.75C147.427 657.883 141.797 655.515 135.459 660.976C138.049 662.743 144.473 664.972 149.45 659.75Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M157.001 663.924C154.723 665.47 151.139 670.416 155.019 677.828C157.328 675.707 160.957 669.956 157.001 663.924Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M166.783 655.509C165.935 658.128 166.141 664.233 173.755 667.702C174.275 664.61 173.61 657.843 166.783 655.509Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M167.439 645.167C168.056 647.85 171.368 652.982 179.683 652.049C178.541 649.128 174.495 643.663 167.439 645.167Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M158.257 631.486C159.573 633.904 164.144 637.956 171.901 634.821C170.016 632.315 164.648 628.14 158.257 631.486Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M155.353 615.357C155.746 618.081 158.623 623.469 166.987 623.226C166.09 620.221 162.509 614.441 155.353 615.357Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M165.426 596.79C164.493 599.38 164.5 605.488 171.996 609.204C172.617 606.131 172.173 599.345 165.426 596.79Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M171.204 585.22C170.964 587.962 172.532 593.865 180.729 595.541C180.544 592.411 178.38 585.965 171.204 585.22Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M172.032 569.528C172.665 572.207 176.01 577.319 184.318 576.334C183.159 573.421 179.079 567.981 172.032 569.528Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M165.194 551.22C166.554 553.614 171.197 557.583 178.896 554.308C176.966 551.837 171.524 547.759 165.194 551.22Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M155.924 535.769C157.283 538.162 161.926 542.131 169.625 538.857C167.696 536.385 162.254 532.307 155.924 535.769Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M145.566 521.952C147.266 524.116 152.449 527.35 159.575 522.965C157.298 520.809 151.31 517.587 145.566 521.952Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M133.519 502.548C134.878 504.941 139.521 508.91 147.22 505.636C145.29 503.164 139.849 499.087 133.519 502.548Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M125.793 483.233C127.152 485.627 131.795 489.596 139.495 486.321C137.565 483.85 132.123 479.772 125.793 483.233Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M125.235 460.841C125.561 463.574 128.307 469.03 136.673 468.991C135.851 465.965 132.411 460.099 125.235 460.841Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M126.007 446.162C126.334 448.895 129.079 454.351 137.446 454.312C136.623 451.286 133.183 445.42 126.007 446.162Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M130.102 431.111C129.83 433.85 131.329 439.772 139.505 441.544C139.357 438.412 137.269 431.941 130.102 431.111Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M141.268 413.681C140.11 416.178 139.579 422.263 146.719 426.625C147.608 423.619 147.764 416.82 141.268 413.681Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M156.771 403.557C154.42 404.989 150.597 409.753 154.107 417.347C156.518 415.342 160.426 409.777 156.771 403.557Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M162.63 643.012C161.246 640.632 156.563 636.711 148.897 640.064C150.852 642.516 156.336 646.537 162.63 643.012Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 2.31773
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M191.16 454.872C199.195 444.056 200.173 429.505 199.658 423.582H164.892C164.377 429.505 165.356 444.056 173.391 454.872H191.16Z",
    fill: "#732F3B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 594,
    cy: 730.5,
    rx: 164,
    ry: 40.5,
    fill: "#732F3B"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.218 351.436C504.308 349.215 497.904 346.38 497.904 346.38C497.904 346.38 491.499 349.215 488.589 351.436C485.679 353.658 483 357.757 483 357.757L485.173 370.009L483 382.043L485.173 394.514L483 418.143H512.807L510.712 394.514L512.807 382.043L510.168 370.009L512.807 357.757C512.807 357.757 510.129 353.658 507.218 351.436Z",
    fill: "#2F305A"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M500.698 339.379C500.698 339.379 503.716 333.361 506.08 330.627C508.445 327.893 512.807 325.376 512.807 325.376L512.807 353.381C512.807 353.381 508.445 350.864 506.08 348.13C503.716 345.396 500.698 339.379 500.698 339.379Z",
    fill: "#2F305A"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M495.109 339.378C495.109 339.378 492.092 345.396 489.727 348.13C487.363 350.864 483 353.381 483 353.381L483 325.376C483 325.376 487.363 327.893 489.727 330.627C492.092 333.361 495.109 339.378 495.109 339.378Z",
    fill: "#2F305A"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M497.904 332.377C497.904 332.377 491.499 329.542 488.589 327.321C485.679 325.099 483 321 483 321L512.808 321C512.808 321 510.129 325.099 507.219 327.321C504.309 329.542 497.904 332.377 497.904 332.377Z",
    fill: "#2F305A"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.218 351.436C553.308 349.215 546.904 346.38 546.904 346.38C546.904 346.38 540.499 349.215 537.589 351.436C534.679 353.658 532 357.757 532 357.757L534.173 370.009L532 382.043L534.173 394.514L532 418.143H561.807L559.712 394.514L561.807 382.043L559.168 370.009L561.807 357.757C561.807 357.757 559.129 353.658 556.218 351.436Z",
    fill: "#2F305A"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M549.698 339.379C549.698 339.379 552.716 333.361 555.08 330.627C557.445 327.893 561.807 325.376 561.807 325.376L561.807 353.381C561.807 353.381 557.445 350.864 555.08 348.13C552.716 345.396 549.698 339.379 549.698 339.379Z",
    fill: "#2F305A"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M544.109 339.378C544.109 339.378 541.092 345.396 538.727 348.13C536.363 350.864 532 353.381 532 353.381L532 325.376C532 325.376 536.363 327.893 538.727 330.627C541.092 333.361 544.109 339.378 544.109 339.378Z",
    fill: "#2F305A"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M546.904 332.377C546.904 332.377 540.499 329.542 537.589 327.321C534.679 325.099 532 321 532 321L561.808 321C561.808 321 559.129 325.099 556.219 327.321C553.309 329.542 546.904 332.377 546.904 332.377Z",
    fill: "#2F305A"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M653 359.031C651 356.492 645.5 351.993 645.5 351.993C645.5 351.993 638.699 354.985 636.062 356.995C633.426 359.005 631 362.713 631 362.713L633.5 371.23L631 382.96L632.969 395.967L631 419.403L658 424.403L655.609 399.382L658 387.183L655.609 373.798L658 366.538C658 366.538 655.609 362.343 653 359.031Z",
    fill: "#242546"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M648.5 345.893C648.5 345.893 649.764 342.226 651.906 339.752C654.048 337.278 658 335.177 658 335.177V360.908C658 360.908 655.142 357.751 653 355.277C650.858 352.804 648.5 345.893 648.5 345.893Z",
    fill: "#242546"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M641.969 345.135C641.969 345.135 639.142 349.947 637 352.42C634.858 354.894 631 357.803 631 357.803L631 329.459C631 329.459 636.358 335.9 638.5 338.374C640.642 340.847 641.969 345.135 641.969 345.135Z",
    fill: "#242546"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 339.752C646.5 339.752 641.136 336.643 638.5 334.633C635.864 332.623 631.5 322.903 631.5 322.903L658 329.459C658 329.459 654.542 334.031 651.906 336.04C649.27 338.05 646.5 339.752 646.5 339.752Z",
    fill: "#242546"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M645.5 323.403C645.5 323.403 639.136 320.953 636.5 318.903C633.864 316.853 631.379 309 631.379 309L656.5 318.5C656.5 318.5 655.136 319.353 652.5 321.403C649.864 323.453 645.5 323.403 645.5 323.403Z",
    fill: "#242546"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M394 359.128C396 356.589 401.5 352.09 401.5 352.09C401.5 352.09 408.301 355.082 410.938 357.092C413.574 359.102 416 362.81 416 362.81L413.5 371.327L416 383.057L414.031 396.065L416 419.5L389 424.5L391.391 399.479L389 387.28L391.391 373.895L389 366.635C389 366.635 391.391 362.44 394 359.128Z",
    fill: "#232443"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M398.5 345.991C398.5 345.991 397.236 342.323 395.094 339.849C392.952 337.376 389 335.275 389 335.275V361.005C389 361.005 391.858 357.848 394 355.375C396.142 352.901 398.5 345.991 398.5 345.991Z",
    fill: "#232443"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M405.031 345.232C405.031 345.232 407.858 350.044 410 352.517C412.142 354.991 416 357.901 416 357.901L416 329.556C416 329.556 410.642 335.997 408.5 338.471C406.358 340.945 405.031 345.232 405.031 345.232Z",
    fill: "#232443"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M400.5 339.849C400.5 339.849 405.864 336.74 408.5 334.73C411.136 332.72 415.5 323 415.5 323L389 330.5C389 330.5 392.458 334.128 395.094 336.138C397.73 338.147 400.5 339.849 400.5 339.849Z",
    fill: "#232443"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M401.5 324.403C401.5 324.403 406.364 321.051 409 319C411.636 316.95 415.621 310 415.621 310L389.5 319.903C389.5 319.903 391.5 321.597 394.5 323C397.5 324.403 401.5 324.403 401.5 324.403Z",
    fill: "#2F305A"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.218 351.436C455.308 349.215 448.904 346.38 448.904 346.38C448.904 346.38 442.499 349.215 439.589 351.436C436.679 353.658 434 357.757 434 357.757L436.173 370.009L434 382.043L436.173 394.514L434 418.143H463.807L461.712 394.514L463.807 382.043L461.168 370.009L463.807 357.757C463.807 357.757 461.129 353.658 458.218 351.436Z",
    fill: "#2F305A"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M451.698 339.379C451.698 339.379 454.716 333.361 457.08 330.627C459.445 327.893 463.807 325.376 463.807 325.376L463.807 353.381C463.807 353.381 459.445 350.864 457.08 348.13C454.716 345.396 451.698 339.379 451.698 339.379Z",
    fill: "#2F305A"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M446.109 339.378C446.109 339.378 443.092 345.396 440.727 348.13C438.363 350.864 434 353.381 434 353.381L434 325.376C434 325.376 438.363 327.893 440.727 330.627C443.092 333.361 446.109 339.378 446.109 339.378Z",
    fill: "#2F305A"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M448.904 332.377C448.904 332.377 442.499 329.542 439.589 327.321C436.679 325.099 434 321 434 321L463.808 321C463.808 321 461.129 325.099 458.219 327.321C455.309 329.542 448.904 332.377 448.904 332.377Z",
    fill: "#2F305A"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M448.714 317.143C448.714 317.143 442.821 314.366 440.143 312.191C437.465 310.015 435 306 435 306L462.429 306C462.429 306 459.964 310.015 457.286 312.191C454.608 314.366 448.714 317.143 448.714 317.143Z",
    fill: "#2F305A"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M497.714 317.143C497.714 317.143 491.821 314.366 489.143 312.191C486.465 310.015 484 306 484 306L511.429 306C511.429 306 508.964 310.015 506.286 312.191C503.608 314.366 497.714 317.143 497.714 317.143Z",
    fill: "#2F305A"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M546.714 317.143C546.714 317.143 540.821 314.366 538.143 312.191C535.465 310.015 533 306 533 306L560.429 306C560.429 306 557.964 310.015 555.286 312.191C552.608 314.366 546.714 317.143 546.714 317.143Z",
    fill: "#2F305A"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M605.218 351.436C602.308 349.215 595.904 346.38 595.904 346.38C595.904 346.38 589.499 349.215 586.589 351.436C583.679 353.658 581 357.757 581 357.757L583.173 370.009L581 382.043L583.173 394.514L581 418.143H610.807L608.712 394.514L610.807 382.043L608.168 370.009L610.807 357.757C610.807 357.757 608.129 353.658 605.218 351.436Z",
    fill: "#2F305A"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M598.698 339.379C598.698 339.379 601.716 333.361 604.08 330.627C606.445 327.893 610.807 325.376 610.807 325.376L610.807 353.381C610.807 353.381 606.445 350.864 604.08 348.13C601.716 345.396 598.698 339.379 598.698 339.379Z",
    fill: "#2F305A"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M593.109 339.379C593.109 339.379 590.092 345.396 587.727 348.13C585.363 350.864 581 353.381 581 353.381L581 325.376C581 325.376 585.363 327.893 587.727 330.627C590.092 333.361 593.109 339.379 593.109 339.379Z",
    fill: "#2F305A"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M595.904 332.377C595.904 332.377 589.499 329.542 586.589 327.321C583.679 325.099 581 321 581 321L610.808 321C610.808 321 608.129 325.099 605.219 327.321C602.309 329.542 595.904 332.377 595.904 332.377Z",
    fill: "#2F305A"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M595.714 317.143C595.714 317.143 589.821 314.366 587.143 312.191C584.465 310.015 582 306 582 306L609.429 306C609.429 306 606.964 310.015 604.286 312.191C601.608 314.366 595.714 317.143 595.714 317.143Z",
    fill: "#2F305A"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.275 205.79C112.598 203.747 106.708 201.139 106.708 201.139C106.708 201.139 100.817 203.747 98.1403 205.79C95.4638 207.833 93 211.603 93 211.603L94.999 222.872L93 233.94L94.999 245.41L93 267.143H120.415L118.488 245.41L120.415 233.94L117.988 222.872L120.415 211.603C120.415 211.603 117.951 207.833 115.275 205.79Z",
    fill: "#212345"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M109.277 194.7C109.277 194.7 112.053 189.165 114.227 186.65C116.402 184.136 120.415 181.821 120.415 181.821L120.415 207.578C120.415 207.578 116.402 205.264 114.227 202.749C112.053 200.234 109.277 194.7 109.277 194.7Z",
    fill: "#212345"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M104.138 194.7C104.138 194.7 101.362 200.234 99.1877 202.749C97.013 205.264 93.0003 207.578 93.0003 207.578L93.0003 181.821C93.0003 181.821 97.013 184.136 99.1877 186.65C101.362 189.165 104.138 194.7 104.138 194.7Z",
    fill: "#212345"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M106.707 188.26C106.707 188.26 100.817 185.653 98.1402 183.61C95.4637 181.566 92.9999 177.796 92.9999 177.796L120.415 177.796C120.415 177.796 117.951 181.566 115.275 183.61C112.598 185.653 106.707 188.26 106.707 188.26Z",
    fill: "#212345"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.2748 205.79C70.5982 203.747 64.7076 201.139 64.7076 201.139C64.7076 201.139 58.8169 203.747 56.1403 205.79C53.4638 207.833 51 211.603 51 211.603L52.999 222.872L51 233.94L52.999 245.41L51 267.143H78.4152L76.4875 245.41L78.4152 233.94L75.9878 222.872L78.4152 211.603C78.4152 211.603 75.9514 207.833 73.2748 205.79Z",
    fill: "#212345"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2773 194.7C67.2773 194.7 70.0526 189.165 72.2273 186.65C74.402 184.136 78.4147 181.821 78.4147 181.821L78.4147 207.578C78.4147 207.578 74.402 205.264 72.2273 202.749C70.0526 200.234 67.2773 194.7 67.2773 194.7Z",
    fill: "#212345"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1377 194.7C62.1377 194.7 59.3625 200.234 57.1877 202.749C55.013 205.264 51.0003 207.578 51.0003 207.578L51.0003 181.821C51.0003 181.821 55.013 184.136 57.1877 186.65C59.3625 189.165 62.1377 194.7 62.1377 194.7Z",
    fill: "#212345"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7075 188.26C64.7075 188.26 58.8168 185.653 56.1402 183.61C53.4637 181.566 50.9999 177.796 50.9999 177.796L78.415 177.796C78.415 177.796 75.9513 181.566 73.2747 183.61C70.5981 185.653 64.7075 188.26 64.7075 188.26Z",
    fill: "#212345"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2748 205.79C28.5982 203.747 22.7076 201.139 22.7076 201.139C22.7076 201.139 16.8169 203.747 14.1403 205.79C11.4638 207.833 9 211.603 9 211.603L10.999 222.872L9 233.94L10.999 245.41L9 267.143H36.4152L34.4875 245.41L36.4152 233.94L33.9878 222.872L36.4152 211.603C36.4152 211.603 33.9514 207.833 31.2748 205.79Z",
    fill: "#212345"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2773 194.7C25.2773 194.7 28.0526 189.165 30.2273 186.65C32.402 184.136 36.4147 181.821 36.4147 181.821L36.4147 207.578C36.4147 207.578 32.402 205.264 30.2273 202.749C28.0526 200.234 25.2773 194.7 25.2773 194.7Z",
    fill: "#212345"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1377 194.7C20.1377 194.7 17.3625 200.234 15.1877 202.749C13.013 205.264 9.00029 207.578 9.00029 207.578L9.00029 181.821C9.00029 181.821 13.013 184.136 15.1877 186.65C17.3625 189.165 20.1377 194.7 20.1377 194.7Z",
    fill: "#212345"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7075 188.26C22.7075 188.26 16.8168 185.653 14.1402 183.61C11.4637 181.566 8.99989 177.796 8.99989 177.796L36.415 177.796C36.415 177.796 33.9513 181.566 31.2747 183.61C28.5981 185.653 22.7075 188.26 22.7075 188.26Z",
    fill: "#212345"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M106.5 174C106.5 174 101.128 171.508 98.6875 169.556C96.2467 167.603 94 164 94 164L119 164C119 164 116.753 167.603 114.313 169.556C111.872 171.508 106.5 174 106.5 174Z",
    fill: "#212345"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 174C64.5 174 59.1283 171.508 56.6875 169.556C54.2467 167.603 52 164 52 164L77 164C77 164 74.7533 167.603 72.3125 169.556C69.8717 171.508 64.5 174 64.5 174Z",
    fill: "#212345"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 174C22.5 174 17.1283 171.508 14.6875 169.556C12.2467 167.603 10 164 10 164L35 164C35 164 32.7533 167.603 30.3125 169.556C27.8717 171.508 22.5 174 22.5 174Z",
    fill: "#212345"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M698.579 383.197C695.986 379.911 690.279 374.495 690.279 374.495C690.279 374.495 684.573 374.095 681.98 374.74C679.387 375.384 677 377.795 677 377.795L678.937 389.623L677 399.283L678.937 411.304L677 431.225L703.559 444.757L701.691 422.898L703.559 412.815L701.207 400.97L703.559 391.327C703.559 391.327 701.172 386.484 698.579 383.197Z",
    fill: "#212345"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M692.77 369.568C692.77 369.568 695.458 365.614 697.565 364.268C699.672 362.922 703.559 362.676 703.559 362.676L703.559 387.455C703.559 387.455 699.672 383.248 697.565 379.755C695.458 376.263 692.77 369.568 692.77 369.568Z",
    fill: "#212345"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M687.789 367.031C687.789 367.031 685.101 370.985 682.994 372.331C680.887 373.677 677 373.923 677 373.923L677 349.144C677 349.144 680.887 353.352 682.994 356.844C685.101 360.337 687.789 367.031 687.789 367.031Z",
    fill: "#212345"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M690.279 362.105C690.279 362.105 684.573 356.689 681.98 353.402C679.387 350.115 677 345.272 677 345.272L703.559 358.805C703.559 358.805 701.172 361.215 698.579 361.86C695.986 362.504 690.279 362.105 690.279 362.105Z",
    fill: "#212345"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M690.111 348.54C690.111 348.54 684.859 343.407 682.473 340.266C680.087 337.125 677.891 332.454 677.891 332.454L702.33 344.906C702.33 344.906 700.134 347.34 697.748 348.049C695.362 348.758 690.111 348.54 690.111 348.54Z",
    fill: "#212345"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M735.579 404.197C732.986 400.911 727.279 395.495 727.279 395.495C727.279 395.495 721.573 395.095 718.98 395.74C716.387 396.384 714 398.795 714 398.795L715.937 410.623L714 420.283L715.937 432.304L714 452.225L740.559 465.757L738.691 443.898L740.559 433.815L738.207 421.97L740.559 412.327C740.559 412.327 738.172 407.484 735.579 404.197Z",
    fill: "#212345"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M729.77 390.568C729.77 390.568 732.458 386.614 734.565 385.268C736.672 383.922 740.559 383.676 740.559 383.676L740.559 408.455C740.559 408.455 736.672 404.248 734.565 400.755C732.458 397.263 729.77 390.568 729.77 390.568Z",
    fill: "#212345"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M724.789 388.031C724.789 388.031 722.101 391.985 719.994 393.331C717.887 394.677 714 394.923 714 394.923L714 370.144C714 370.144 717.887 374.352 719.994 377.844C722.101 381.337 724.789 388.031 724.789 388.031Z",
    fill: "#212345"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M727.279 383.105C727.279 383.105 721.573 377.689 718.98 374.402C716.387 371.115 714 366.272 714 366.272L740.559 379.805C740.559 379.805 738.172 382.215 735.579 382.86C732.986 383.504 727.279 383.105 727.279 383.105Z",
    fill: "#212345"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M727.111 369.54C727.111 369.54 721.859 364.407 719.473 361.266C717.087 358.125 714.891 353.454 714.891 353.454L739.33 365.906C739.33 365.906 737.134 368.34 734.748 369.049C732.362 369.758 727.111 369.54 727.111 369.54Z",
    fill: "#212345"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M775.579 425.197C772.986 421.911 767.279 416.495 767.279 416.495C767.279 416.495 761.573 416.095 758.98 416.74C756.387 417.384 754 419.795 754 419.795L755.937 431.623L754 441.283L755.937 453.304L754 473.225L780.559 486.757L778.691 464.898L780.559 454.815L778.207 442.97L780.559 433.327C780.559 433.327 778.172 428.484 775.579 425.197Z",
    fill: "#212345"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M769.77 411.568C769.77 411.568 772.458 407.614 774.565 406.268C776.672 404.922 780.559 404.676 780.559 404.676L780.559 429.455C780.559 429.455 776.672 425.248 774.565 421.755C772.458 418.263 769.77 411.568 769.77 411.568Z",
    fill: "#212345"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M764.789 409.031C764.789 409.031 762.101 412.985 759.994 414.331C757.887 415.677 754 415.923 754 415.923L754 391.144C754 391.144 757.887 395.352 759.994 398.844C762.101 402.337 764.789 409.031 764.789 409.031Z",
    fill: "#212345"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M767.279 404.105C767.279 404.105 761.573 398.689 758.98 395.402C756.387 392.115 754 387.272 754 387.272L780.559 400.805C780.559 400.805 778.172 403.215 775.579 403.86C772.986 404.504 767.279 404.105 767.279 404.105Z",
    fill: "#212345"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M767.111 390.54C767.111 390.54 761.859 385.407 759.473 382.266C757.087 379.125 754.891 374.454 754.891 374.454L779.33 386.906C779.33 386.906 777.134 389.34 774.748 390.049C772.362 390.758 767.111 390.54 767.111 390.54Z",
    fill: "#212345"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M814.579 447.197C811.986 443.911 806.279 438.495 806.279 438.495C806.279 438.495 800.573 438.095 797.98 438.74C795.387 439.384 793 441.795 793 441.795L794.937 453.623L793 463.283L794.937 475.304L793 495.225L819.559 508.757L817.691 486.898L819.559 476.815L817.207 464.97L819.559 455.327C819.559 455.327 817.172 450.484 814.579 447.197Z",
    fill: "#212345"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M808.77 433.568C808.77 433.568 811.458 429.614 813.565 428.268C815.672 426.922 819.559 426.676 819.559 426.676L819.559 451.455C819.559 451.455 815.672 447.248 813.565 443.755C811.458 440.263 808.77 433.568 808.77 433.568Z",
    fill: "#212345"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M803.789 431.031C803.789 431.031 801.101 434.985 798.994 436.331C796.887 437.677 793 437.923 793 437.923L793 413.144C793 413.144 796.887 417.352 798.994 420.844C801.101 424.337 803.789 431.031 803.789 431.031Z",
    fill: "#212345"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M806.279 426.105C806.279 426.105 800.573 420.689 797.98 417.402C795.387 414.115 793 409.272 793 409.272L819.559 422.805C819.559 422.805 817.172 425.215 814.579 425.86C811.986 426.504 806.279 426.105 806.279 426.105Z",
    fill: "#212345"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M806.111 412.54C806.111 412.54 800.859 407.407 798.473 404.266C796.087 401.125 793.891 396.454 793.891 396.454L818.33 408.906C818.33 408.906 816.134 411.34 813.748 412.049C811.362 412.758 806.111 412.54 806.111 412.54Z",
    fill: "#212345"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.311 227.393C159.871 223.842 154.499 217.846 154.499 217.846C154.499 217.846 149.128 216.866 146.687 217.246C144.247 217.627 142 219.795 142 219.795L143.823 231.82L142 241.283L143.823 253.501L142 273.225L166.999 289.459L165.241 267.41L166.999 257.517L164.785 245.433L166.999 236.029C166.999 236.029 164.752 230.943 162.311 227.393Z",
    fill: "#212345"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M156.843 213.173C156.843 213.173 159.373 209.492 161.356 208.36C163.339 207.229 166.998 207.378 166.998 207.378L166.998 232.157C166.998 232.157 163.339 227.554 161.356 223.847C159.373 220.14 156.843 213.173 156.843 213.173Z",
    fill: "#212345"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M152.155 210.129C152.155 210.129 149.625 213.81 147.642 214.941C145.659 216.073 142 215.923 142 215.923L142 191.144C142 191.144 145.659 195.747 147.642 199.454C149.625 203.161 152.155 210.129 152.155 210.129Z",
    fill: "#212345"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M154.499 205.456C154.499 205.456 149.127 199.459 146.687 195.909C144.246 192.358 142 187.272 142 187.272L166.998 203.507C166.998 203.507 164.751 205.674 162.311 206.055C159.87 206.436 154.499 205.456 154.499 205.456Z",
    fill: "#212345"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M154.341 191.873C154.341 191.873 149.398 186.207 147.152 182.823C144.907 179.44 142.839 174.545 142.839 174.545L165.843 189.483C165.843 189.483 163.775 191.693 161.53 192.16C159.284 192.626 154.341 191.873 154.341 191.873Z",
    fill: "#212345"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.311 252.393C199.871 248.842 194.499 242.846 194.499 242.846C194.499 242.846 189.128 241.866 186.687 242.246C184.247 242.627 182 244.795 182 244.795L183.823 256.82L182 266.283L183.823 278.501L182 298.225L206.999 314.459L205.241 292.41L206.999 282.517L204.785 270.433L206.999 261.029C206.999 261.029 204.752 255.943 202.311 252.393Z",
    fill: "#212345"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M196.843 238.173C196.843 238.173 199.373 234.492 201.356 233.36C203.339 232.229 206.998 232.378 206.998 232.378L206.998 257.157C206.998 257.157 203.339 252.554 201.356 248.847C199.373 245.14 196.843 238.173 196.843 238.173Z",
    fill: "#212345"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M192.155 235.129C192.155 235.129 189.625 238.81 187.642 239.941C185.659 241.073 182 240.923 182 240.923L182 216.144C182 216.144 185.659 220.747 187.642 224.454C189.625 228.161 192.155 235.129 192.155 235.129Z",
    fill: "#212345"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M194.499 230.456C194.499 230.456 189.127 224.459 186.687 220.909C184.246 217.358 182 212.272 182 212.272L206.998 228.507C206.998 228.507 204.751 230.674 202.311 231.055C199.87 231.436 194.499 230.456 194.499 230.456Z",
    fill: "#212345"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M194.341 216.873C194.341 216.873 189.398 211.207 187.152 207.823C184.907 204.44 182.839 199.545 182.839 199.545L205.843 214.483C205.843 214.483 203.775 216.693 201.53 217.16C199.284 217.626 194.341 216.873 194.341 216.873Z",
    fill: "#212345"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.311 277.393C239.871 273.842 234.499 267.846 234.499 267.846C234.499 267.846 229.128 266.866 226.687 267.246C224.247 267.627 222 269.795 222 269.795L223.823 281.82L222 291.283L223.823 303.501L222 323.225L246.999 339.459L245.241 317.41L246.999 307.517L244.785 295.433L246.999 286.029C246.999 286.029 244.752 280.943 242.311 277.393Z",
    fill: "#212345"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M236.843 263.173C236.843 263.173 239.373 259.492 241.356 258.36C243.339 257.229 246.998 257.378 246.998 257.378L246.998 282.157C246.998 282.157 243.339 277.554 241.356 273.847C239.373 270.14 236.843 263.173 236.843 263.173Z",
    fill: "#212345"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M232.155 260.129C232.155 260.129 229.625 263.81 227.642 264.941C225.659 266.073 222 265.923 222 265.923L222 241.144C222 241.144 225.659 245.747 227.642 249.454C229.625 253.161 232.155 260.129 232.155 260.129Z",
    fill: "#212345"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M234.499 255.456C234.499 255.456 229.127 249.459 226.687 245.909C224.246 242.358 222 237.272 222 237.272L246.998 253.507C246.998 253.507 244.751 255.674 242.311 256.055C239.87 256.436 234.499 255.456 234.499 255.456Z",
    fill: "#212345"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M234.341 241.873C234.341 241.873 229.398 236.207 227.152 232.823C224.907 229.44 222.839 224.545 222.839 224.545L245.843 239.483C245.843 239.483 243.775 241.693 241.53 242.16C239.284 242.626 234.341 241.873 234.341 241.873Z",
    fill: "#212345"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.311 302.393C278.871 298.842 273.499 292.846 273.499 292.846C273.499 292.846 268.128 291.866 265.687 292.246C263.247 292.627 261 294.795 261 294.795L262.823 306.82L261 316.283L262.823 328.501L261 348.225L285.999 364.459L284.241 342.41L285.999 332.517L283.785 320.433L285.999 311.029C285.999 311.029 283.752 305.943 281.311 302.393Z",
    fill: "#212345"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M275.843 288.173C275.843 288.173 278.373 284.492 280.356 283.36C282.339 282.229 285.998 282.378 285.998 282.378L285.998 307.157C285.998 307.157 282.339 302.554 280.356 298.847C278.373 295.14 275.843 288.173 275.843 288.173Z",
    fill: "#212345"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M271.155 285.129C271.155 285.129 268.625 288.81 266.642 289.941C264.659 291.073 261 290.923 261 290.923L261 266.144C261 266.144 264.659 270.747 266.642 274.454C268.625 278.161 271.155 285.129 271.155 285.129Z",
    fill: "#212345"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M273.499 280.456C273.499 280.456 268.127 274.459 265.687 270.909C263.246 267.358 261 262.272 261 262.272L285.998 278.507C285.998 278.507 283.751 280.674 281.311 281.055C278.87 281.436 273.499 280.456 273.499 280.456Z",
    fill: "#212345"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M273.341 266.873C273.341 266.873 268.398 261.207 266.152 257.823C263.907 254.44 261.839 249.545 261.839 249.545L284.843 264.483C284.843 264.483 282.775 266.693 280.53 267.16C278.284 267.626 273.341 266.873 273.341 266.873Z",
    fill: "#212345"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.311 329.393C319.871 325.842 314.499 319.846 314.499 319.846C314.499 319.846 309.128 318.866 306.687 319.246C304.247 319.627 302 321.795 302 321.795L303.823 333.82L302 343.283L303.823 355.501L302 375.225L326.999 391.459L325.241 369.41L326.999 359.517L324.785 347.433L326.999 338.029C326.999 338.029 324.752 332.943 322.311 329.393Z",
    fill: "#212345"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M316.843 315.173C316.843 315.173 319.373 311.492 321.356 310.36C323.339 309.229 326.998 309.378 326.998 309.378L326.998 334.157C326.998 334.157 323.339 329.554 321.356 325.847C319.373 322.14 316.843 315.173 316.843 315.173Z",
    fill: "#212345"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M312.155 312.129C312.155 312.129 309.625 315.81 307.642 316.941C305.659 318.073 302 317.923 302 317.923L302 293.144C302 293.144 305.659 297.747 307.642 301.454C309.625 305.161 312.155 312.129 312.155 312.129Z",
    fill: "#212345"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M314.499 307.456C314.499 307.456 309.127 301.459 306.687 297.909C304.246 294.358 302 289.272 302 289.272L326.998 305.507C326.998 305.507 324.751 307.674 322.311 308.055C319.87 308.436 314.499 307.456 314.499 307.456Z",
    fill: "#212345"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M314.341 293.873C314.341 293.873 309.398 288.207 307.152 284.823C304.907 281.44 302.839 276.545 302.839 276.545L325.843 291.483C325.843 291.483 323.775 293.693 321.53 294.16C319.284 294.626 314.341 293.873 314.341 293.873Z",
    fill: "#212345"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.311 355.393C360.871 351.842 355.499 345.846 355.499 345.846C355.499 345.846 350.128 344.866 347.687 345.246C345.247 345.627 343 347.795 343 347.795L344.823 359.82L343 369.283L344.823 381.501L343 401.225L367.999 417.459L366.241 395.41L367.999 385.517L365.785 373.433L367.999 364.029C367.999 364.029 365.752 358.943 363.311 355.393Z",
    fill: "#212345"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M357.843 341.173C357.843 341.173 360.373 337.492 362.356 336.36C364.339 335.229 367.998 335.378 367.998 335.378L367.998 360.157C367.998 360.157 364.339 355.554 362.356 351.847C360.373 348.14 357.843 341.173 357.843 341.173Z",
    fill: "#212345"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M353.155 338.129C353.155 338.129 350.625 341.81 348.642 342.941C346.659 344.073 343 343.923 343 343.923L343 319.144C343 319.144 346.659 323.747 348.642 327.454C350.625 331.161 353.155 338.129 353.155 338.129Z",
    fill: "#212345"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M355.499 333.456C355.499 333.456 350.127 327.459 347.687 323.909C345.246 320.358 343 315.272 343 315.272L367.998 331.507C367.998 331.507 365.751 333.674 363.311 334.055C360.87 334.436 355.499 333.456 355.499 333.456Z",
    fill: "#212345"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M355.341 319.873C355.341 319.873 350.398 314.207 348.152 310.823C345.907 307.44 343.839 302.545 343.839 302.545L366.843 317.483C366.843 317.483 364.775 319.693 362.53 320.16C360.284 320.626 355.341 319.873 355.341 319.873Z",
    fill: "#212345"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3713_15982",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 423,
    y: 537,
    width: 200,
    height: 138
  }, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 423.819,
    y: 537.442,
    width: 198.24,
    height: 136.565,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3713_15982)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.809,
    y: 623.297,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.752,
    y: 536.723,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.721,
    y: 640.612,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.377,
    y: 554.037,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.346,
    y: 657.926,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.527,
    y: 571.352,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.779,
    y: 588.667,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.976,
    y: 605.982,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.559,
    y: 623.297,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.502,
    y: 536.723,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.471,
    y: 640.612,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.127,
    y: 554.037,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.096,
    y: 657.926,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.277,
    y: 571.352,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.53,
    y: 588.667,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470.726,
    y: 605.982,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.309,
    y: 623.297,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509.252,
    y: 536.723,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.221,
    y: 640.612,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.877,
    y: 554.037,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 482.846,
    y: 657.926,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.027,
    y: 571.352,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.28,
    y: 588.667,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.476,
    y: 605.982,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 533.059,
    y: 623.297,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556.002,
    y: 536.723,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.971,
    y: 640.612,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.627,
    y: 554.037,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.596,
    y: 657.926,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 547.777,
    y: 571.352,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.03,
    y: 588.667,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.226,
    y: 605.982,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.81,
    y: 623.297,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.752,
    y: 536.723,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.721,
    y: 640.612,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.377,
    y: 554.037,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.346,
    y: 657.926,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.527,
    y: 571.352,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.78,
    y: 588.667,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.976,
    y: 605.982,
    width: 46.4364,
    height: 17.0012,
    fill: "#454675",
    stroke: "#8789BF",
    strokeWidth: 0.313605
  }))), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 520,
    width: 214.551,
    height: 17.6784,
    fill: "#626492"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 452.895,
    y: 570.922,
    width: 141.851,
    height: 103.085,
    fill: "#0B0F21"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M459.062 572.684C459.062 572.684 519.599 577.258 548.93 609.37C575.489 638.448 581.529 674.007 581.529 674.007H459.062V572.684Z",
    fill: "#454675"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 452.895,
    y: 570.922,
    width: 141.851,
    height: 1.76213,
    fill: "#C66238"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M452.895 570.922L461.705 572.67V674.007H452.895V570.922Z",
    fill: "#D38337"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 452.895,
    y: 665.196,
    width: 141.851,
    height: 8.81065,
    fill: "#373856"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M492.983 657.707C492.278 668.28 501.206 672.979 505.758 674.007H541.441C548.137 674.007 552.161 668.427 553.336 665.637C560.384 653.654 541.441 643.17 541.441 643.17C550.252 656.386 542.322 659.469 540.12 660.791C537.917 662.113 539.239 655.064 537.036 651.98C535.274 649.513 527.785 645.813 529.987 640.527C523.82 646.253 528.225 652.421 526.023 657.707C523.82 662.994 523.82 659.469 522.058 657.267C520.453 655.261 525.142 651.099 522.058 639.205C518.643 626.034 521.177 619.822 521.177 619.822C521.177 619.822 508.401 629.073 507.52 641.848C506.815 652.069 504.583 656.679 503.556 657.707C507.785 649.954 502.674 640.673 500.031 639.205C499.15 651.54 493.688 647.135 492.983 657.707Z",
    fill: "#D38337",
    stroke: "#D38337",
    strokeWidth: 0.808989,
    strokeLinecap: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M508.155 674.007C505.113 673.305 499.146 670.096 499.617 662.875C500.088 655.655 505.318 658.148 503.115 647.135C504.882 648.137 509.509 657.58 506.683 662.875C507.37 662.173 509.332 659.04 509.332 652.045C509.332 635.681 515.009 635.681 515.009 635.681C515.009 635.681 514.128 640.967 519.048 648.016C520.709 650.396 521.611 652.654 522.124 654.646C522.404 651.766 523.503 649.093 527.344 648.016C524.701 653.742 526.607 657.785 527.785 659.469C529.257 661.575 529.646 665.884 531.118 664.981C532.59 664.079 538.358 663.434 533.952 653.742C533.952 653.742 544.661 660.108 539.95 668.291C539.165 670.196 536.477 674.007 532.002 674.007H508.155Z",
    fill: "#C66238",
    stroke: "#C66238",
    strokeWidth: 0.808989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M518.417 663.8C519.368 662.242 521.527 661.827 523.241 662.873C523.336 662.931 523.427 662.992 523.516 663.056L523.523 663.045L533.111 668.897L533.104 668.908C534.607 670.003 535.108 671.967 534.21 673.438C533.313 674.909 531.336 675.361 529.676 674.526L529.669 674.537L529.403 674.375C529.398 674.372 529.392 674.369 529.387 674.365C529.382 674.362 529.376 674.359 529.371 674.355L520.08 668.685L520.087 668.674C519.99 668.625 519.893 668.571 519.798 668.513C518.085 667.468 517.466 665.357 518.417 663.8Z",
    fill: "#454675"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 520.954,
    cy: 665.348,
    rx: 3.192,
    ry: 3.30399,
    transform: "rotate(-148.604 520.954 665.348)",
    fill: "#2F315A"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M530.428 671.143C530.428 672.968 528.801 674.447 526.794 674.447C526.682 674.447 526.572 674.443 526.463 674.434V674.447H515.577C515.572 674.447 515.566 674.447 515.56 674.447C515.554 674.447 515.549 674.447 515.543 674.447H515.23V674.434C513.377 674.282 511.926 672.867 511.926 671.143C511.926 669.42 513.377 668.005 515.23 667.853V667.839H526.463V667.853C526.572 667.844 526.682 667.839 526.794 667.839C528.801 667.839 530.428 669.319 530.428 671.143Z",
    fill: "#454675"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 527.014,
    cy: 671.143,
    rx: 3.63439,
    ry: 3.30399,
    fill: "#2F315A"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M849.853 473.768C847.443 469.646 842.227 461.982 842.227 461.982C842.227 461.982 837.09 458.66 834.76 457.73C832.43 456.659 830.307 457.27 830.307 457.27C830.932 461.852 831.547 466.594 832.182 471.497C831.646 474.919 831.121 478.39 830.595 481.892C831.22 487.035 831.825 491.987 832.459 496.76C831.934 503.433 831.388 509.886 830.823 516.199C838.479 528.615 846.402 542.612 854.861 558C854.613 546.955 854.098 535.989 853.453 525.124C853.979 520.641 854.484 516.119 855 511.537C854.177 505.694 853.354 500.021 852.551 494.498C853.195 490.566 853.146 489.542 853.8 486C853.8 486 852.253 477.81 849.853 473.768Z",
    fill: "#191A3C"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M844.379 458.5C844.379 458.5 846.69 456.129 848.534 455.899C850.379 455.679 853.8 457.28 853.8 457.28C854.008 464.463 854.226 471.837 854.435 479.391C854.435 479.391 850.835 474.178 848.871 470.086C846.908 465.924 844.379 458.5 844.379 458.5Z",
    fill: "#191A3C"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M839.877 453.728C839.877 453.728 837.537 455.999 835.653 456.049C833.768 456.029 830.288 453.568 830.288 453.568C830.208 446.134 830.129 438.861 830.06 431.747C830.06 431.747 833.53 437.67 835.454 441.952C837.388 446.224 839.877 453.728 839.877 453.728Z",
    fill: "#191A3C"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M842.029 450.506C842.029 450.506 836.843 442.682 834.502 438.35C832.162 433.998 830 428.455 830 428.455C837.864 437.18 845.787 445.644 853.701 453.938C853.701 453.938 851.658 454.889 849.377 454.248C847.096 453.598 842.029 450.506 842.029 450.506Z",
    fill: "#191A3C"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M841.593 438.38C841.593 438.38 836.852 431.187 834.691 427.185C832.529 423.193 830.545 418 830.545 418C837.685 425.734 844.954 433.478 852.223 441.302C852.223 441.302 850.369 442.322 848.296 441.752C846.214 441.172 841.593 438.38 841.593 438.38Z",
    fill: "#191A3C"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M870.099 468.505C872.539 473.727 877.886 483.79 877.886 483.79C877.886 483.79 883.182 488.482 885.572 489.742C887.952 491.035 892.5 488.001 892.5 488.001C882.5 477.759 873.765 466.715 865.319 457C865.319 457 867.597 463.432 870.099 468.505Z",
    fill: "#191A3C"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M877.856 500.849C877.856 500.849 872.175 489.145 869.552 483.16C866.939 477.408 864.499 470.263 864.499 470.263C873.522 481.983 882.5 492 892.5 504.595C892.5 504.595 888.63 510.779 886.089 508.873C883.496 506.983 877.856 500.849 877.856 500.849Z",
    fill: "#191A3C"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M870.443 506.419C872.559 506.834 875.304 504.595 875.304 504.595C875.304 504.595 872.671 493.936 870.575 488.001C868.448 482.265 864.529 474.556 864.529 474.556C864.519 483.757 864.529 491.416 864.499 500.849L870.443 506.419Z",
    fill: "#191A3C"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M880.215 512.785C880.215 512.785 882.929 510.464 885.046 510.928C887.132 511.426 890.889 515.388 890.889 515.388C890.706 526.429 890.585 537.105 890.554 547.085C890.554 547.085 886.767 537.934 884.762 531.187C882.737 524.34 880.215 512.785 880.215 512.785Z",
    fill: "#191A3C"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M885.704 536.724C883.192 529.628 877.653 516.498 877.653 516.498C877.653 516.498 871.992 510.099 869.4 508.259C866.797 506.469 864.134 504.595 864.134 504.595C864.711 509.569 865.613 516.896 866.19 521.986C865.491 524.655 864.823 527.241 864.134 529.811C864.681 535.348 865.187 541.167 865.684 547.234C864.833 554.379 863.942 561.673 863 569.051C873 591 883.5 606 889.309 619C888.975 609.07 888.6 599.256 888.165 589.524C888.914 585.579 889.623 581.667 890.352 577.787C889.592 572.416 888.843 566.929 888.114 561.392C888.944 558.043 889.765 554.777 890.565 551.611C890.565 551.611 888.195 543.554 885.704 536.724Z",
    fill: "#191A3C"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M926.913 584.883C923.889 579.045 917.288 568.669 917.288 568.669C917.288 568.669 910.775 565.295 907.821 564.914C904.866 564.534 902.148 566.712 902.148 566.712C902.899 572.396 903.65 578.026 904.401 583.603C903.663 587.361 902.926 591.066 902.188 594.719C902.926 600.296 903.657 608.338 904.401 614C903.631 621.834 902.853 627.164 902.049 634.835C912.142 650.474 922.285 678.529 932.733 695C932.068 682.908 929.198 656.543 928.5 644.5C929.231 639.572 932.275 636.905 933 631.905C932.078 625.193 931.149 618.569 930.213 612.032C931.096 607.492 931.966 603.025 932.822 598.632C932.822 598.632 929.966 590.71 926.913 584.883Z",
    fill: "#191A3C"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M920.035 563.021C920.035 563.021 922.999 558.896 925.341 558.124C927.674 557.384 932.012 559.119 932.012 559.119C932.262 570.414 932.503 581.763 932.733 593.164C932.733 593.164 928.178 585.475 925.697 579.605C923.217 573.693 920.035 563.021 920.035 563.021Z",
    fill: "#191A3C"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M914.353 556.972C914.353 556.972 911.358 561.192 908.957 562.048C906.575 562.894 902.138 561.329 902.138 561.329C902.105 549.653 902.066 537.959 902.02 526.247C902.02 526.247 906.427 534.211 908.819 540.208C911.24 546.226 914.353 556.972 914.353 556.972Z",
    fill: "#191A3C"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M917.1 551.334C917.1 551.334 910.597 540.811 907.643 534.835C904.708 528.849 902 520.758 902 520.758C911.955 531.764 921.919 542.789 931.893 553.83C931.893 553.83 929.304 555.819 926.419 555.332C923.523 554.856 917.1 551.334 917.1 551.334Z",
    fill: "#191A3C"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M916.685 532.265C916.685 532.265 910.765 522.239 908.077 516.527C905.39 510.795 902.919 503 902.919 503C911.984 513.252 921.053 523.599 930.124 534.042C930.124 534.042 927.772 536.147 925.144 535.776C922.515 535.427 916.685 532.265 916.685 532.265Z",
    fill: "#191A3C"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M972.968 643.205C969.635 637.392 962.279 627.198 962.279 627.198C962.279 627.198 954.88 623.916 951.536 623.336C948.182 622.526 945.108 624.096 945.108 624.096C945.935 630.293 946.769 636.669 947.61 643.225C946.769 647.8 945.935 652.406 945.108 657.041C945.928 664.131 946.751 671.294 947.578 678.531C946.693 688.855 943.949 697.242 943 707.5C954.275 726.829 966.827 753 979.299 774.5C978.479 758.46 978.084 735.043 977.206 719.249C977.969 712.526 978.724 705.763 979.471 698.96C978.407 690.556 977.35 682.356 976.3 674.359C977.286 668.41 978.285 662.674 979.299 657.151C979.299 657.151 976.279 648.958 972.968 643.205Z",
    fill: "#191A3C"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M965.698 620.895C965.698 620.895 969.236 616.013 972.018 614.652C974.801 613.262 979.957 613.902 979.957 613.902C979.813 626.067 979.669 638.409 979.525 650.928C979.525 650.928 974.553 643.555 971.867 637.632C969.16 631.7 965.698 620.895 965.698 620.895Z",
    fill: "#191A3C"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M959.237 615.363C959.237 615.363 955.753 619.765 953.025 620.545C950.307 621.165 945.28 618.804 945.28 618.804C945.28 607.919 945.27 597.161 945.248 586.53C945.248 586.53 950.274 593.703 953.014 599.255C955.753 604.908 959.237 615.363 959.237 615.363Z",
    fill: "#191A3C"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M962.484 609.31C962.484 609.31 955.052 599.676 951.676 594.213C948.311 588.801 945.28 576.565 945.28 576.565C956.5 589.961 968.287 599.415 980 608.219C980 608.219 976.797 611.141 973.356 611.421C969.948 611.641 962.484 609.31 962.484 609.31Z",
    fill: "#191A3C"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M962.139 589.961C962.139 589.961 955.236 581.467 952.097 576.565C948.991 571.753 947.75 559 947.75 559C957 567.5 967.5 578.5 978.307 587.29C978.307 587.29 975.373 590.421 972.18 590.942C969.02 591.462 962.139 589.961 962.139 589.961Z",
    fill: "#191A3C"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 995,
    y: 579,
    width: 7,
    height: 221,
    fill: "#696A9C"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M825 402L831 402L1002 579L995 579L825 402Z",
    fill: "#7677B1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3713_15982",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 550,
    y: 110,
    width: 109,
    height: 83
  }, _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 110,
    width: 108.091,
    height: 82,
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3713_15982)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 621.392,
    y: 146.986,
    width: 12.3287,
    height: 11.1818,
    fill: "#999898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.361 176.804C647.705 175.657 647.504 168.967 647.361 165.766L639.906 168.92L641.483 178.955V184.832C641.483 188.158 642.534 193.099 643.06 195.154L648.077 194.724C649.368 188.416 647.791 182.682 647.361 181.965C646.93 181.248 646.93 178.238 647.361 176.804Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.794 163.902L614.675 169.35C614.436 171.835 613.93 176.89 613.815 177.234C613.672 177.664 613.385 183.255 613.242 183.972C613.127 184.546 610.231 190.805 608.798 193.864C607.268 194.676 604.153 195.727 603.923 193.434C603.637 190.567 606.361 180.962 606.504 180.675C606.647 180.388 606.934 178.955 607.794 177.234C608.482 175.858 608.081 167.773 607.794 163.902Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569.784,
    y: 145.839,
    width: 12.3287,
    height: 9.74825,
    fill: "#999898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.574 178.955C591.23 178.152 590.379 170.497 589.997 166.769C589.997 165.278 594.68 164.237 597.021 163.902C596.907 165.049 597.547 174.033 597.882 178.381C598.885 179.815 599.602 184.832 600.032 186.266C600.376 187.413 600.462 191.713 600.462 193.72H594.298C594.154 193.147 592.864 188.99 592.721 187.556C592.577 186.122 592.004 179.958 591.574 178.955Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.892 164.332C560.58 164.676 562.664 166.1 563.619 166.769C562.807 171.596 561.182 181.392 561.182 181.965V185.836V193.72H555.161C554.731 193.004 554.588 187.556 554.588 185.836C554.588 184.116 555.161 178.955 555.591 177.521C556.021 176.088 555.591 166.339 555.591 166.053C555.591 165.766 559.032 163.902 559.892 164.332Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.773 153.595C577.015 153.117 579.787 151.932 580.934 151.015C582.081 150.097 586.955 151.493 589.248 152.305C590.539 152.878 593.291 154.025 593.979 154.025C594.839 154.025 599.57 157.036 599.283 159.186C598.997 161.336 598.28 162.77 597.706 162.77C597.133 162.77 594.839 161.91 593.119 163.487C591.399 165.064 589.535 164.777 589.822 166.354C590.108 167.931 591.542 170.655 590.395 171.515C589.478 172.203 590.682 174.286 591.399 175.242C591.255 176.006 590.854 177.593 590.395 177.822C589.822 178.109 590.395 180.259 590.395 180.403C590.395 180.517 591.733 181.597 592.402 182.123C593.406 186.185 595.384 194.538 595.269 195.455L561.007 195.885C560.915 191.643 561.081 183.014 562.432 181.281C562.769 180.606 563.444 178.969 563.444 177.822C563.444 176.389 562.28 173.092 562.432 171.515C562.584 169.938 564.448 167.214 564.448 166.784C564.448 166.44 563.205 165.972 562.584 165.78C561.103 164.968 557.71 163.687 555.99 165.064C555.607 165.207 554.843 165.178 554.843 163.917C554.843 162.34 554.269 160.906 554.843 159.616C555.416 158.326 557.423 156.749 557.997 156.319C558.57 155.889 559.717 154.168 561.581 154.599C563.444 155.029 567.458 154.455 567.601 154.025C567.716 153.681 569.274 152.257 570.039 151.588C571.472 152.454 574.626 154.067 575.773 153.595Z",
    fill: "#454675"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.432 181.281C561.081 183.014 560.915 191.643 561.007 195.885L595.269 195.455C595.384 194.538 593.406 186.185 592.402 182.123C591.733 181.597 590.395 180.517 590.395 180.403C590.395 180.259 589.822 178.109 590.395 177.822C590.854 177.593 591.255 176.006 591.399 175.242C590.682 174.286 589.478 172.203 590.395 171.515C591.542 170.655 590.108 167.931 589.822 166.354C589.535 164.777 591.399 165.064 593.119 163.487C594.839 161.91 597.133 162.77 597.706 162.77C598.28 162.77 598.997 161.336 599.283 159.186C599.57 157.036 594.839 154.025 593.979 154.025C593.291 154.025 590.539 152.878 589.248 152.305C586.955 151.493 582.081 150.097 580.934 151.015C579.787 151.932 577.015 153.117 575.773 153.595C574.626 154.067 571.472 152.454 570.039 151.588C569.274 152.257 567.716 153.681 567.601 154.025C567.458 154.455 563.444 155.029 561.581 154.599C559.717 154.168 558.57 155.889 557.997 156.319C557.423 156.749 555.416 158.326 554.843 159.616C554.269 160.906 554.843 162.34 554.843 163.917C554.843 165.178 555.607 165.207 555.99 165.064C557.71 163.687 561.103 164.968 562.584 165.78C563.205 165.972 564.448 166.44 564.448 166.784C564.448 167.214 562.584 169.938 562.432 171.515C562.28 173.092 563.444 176.389 563.444 177.822C563.444 178.969 562.769 180.606 562.432 181.281ZM562.432 181.281C562.481 181.218 562.532 181.164 562.584 181.12C564.075 179.858 563.104 180.701 562.432 181.281Z",
    stroke: "#454675",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.236 165.059C590.465 163.797 591.287 163.864 591.67 164.056C591.67 163.817 591.842 163.339 592.53 163.339C593.39 163.339 593.247 163.052 594.393 162.335C595.54 161.618 595.11 161.618 596.83 161.618C598.551 161.618 597.404 161.762 598.551 161.618C599.698 161.475 600.558 162.909 600.701 164.056C600.844 165.202 598.981 164.486 598.551 165.059C598.121 165.632 597.691 165.059 596.83 165.059C595.97 165.059 595.827 166.206 595.11 166.636C594.393 167.066 593.82 166.636 592.817 166.636C591.813 166.636 591.096 168.07 590.236 168.213C589.376 168.356 589.949 166.636 590.236 165.059Z",
    fill: "#8689CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.988 163.339C560.363 163.339 560.636 163.667 560.807 164C561.246 164.264 561.808 164.486 562.425 164.486C563.858 164.486 563.858 165.632 564.145 166.063C564.432 166.493 563.142 168.213 562.855 167.066C562.568 165.919 561.851 166.063 561.421 165.632C560.991 165.202 559.988 166.063 558.984 166.063C557.981 166.063 556.834 166.636 555.687 167.639C554.54 168.643 554.254 167.066 553.393 166.063C552.533 165.059 554.11 164.486 556.261 164.486C557.264 164.486 556.834 164.056 558.984 164.486C559.701 164.916 559.271 163.339 559.988 163.339Z",
    fill: "#8689CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.714 177.531C590.809 178.439 591.038 179.911 590.714 179.928C589.328 180.001 584.463 179.907 578.624 179.898C579.245 184.365 580.621 195.355 580.392 196.157L573.081 195.871C572.938 191.4 573.119 180.794 573.463 180.398C573.893 179.904 571.456 180.892 571.026 179.928C567.079 179.98 564.007 180.107 563.715 180.398C562.425 180.398 562.167 179.366 562.855 177.531C564.658 177.414 567.588 177.07 570.664 176.83C570.861 176.457 571.201 176.145 571.743 175.954C574.18 175.094 574.467 176.607 574.754 176.599C575.87 176.568 577.036 176.572 578.216 176.602C579.186 175.963 580.253 175.373 580.631 175.524C580.889 175.627 581.22 176.127 581.493 176.742C585.009 176.947 588.381 177.298 590.714 177.531Z",
    fill: "#8689CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.224 131.867C566.256 125.559 571.293 123.026 573.682 122.549C573.348 122.166 573.74 121.631 577.983 122.549C583.287 123.695 582.857 126.563 585.151 129.43C587.444 132.297 587.444 137.171 587.588 137.744C587.731 138.318 588.305 141.615 589.738 142.475C591.172 143.335 592.319 146.653 592.749 149.643C593.179 152.633 587.588 155.664 586.298 155.664C585.007 155.664 584.434 154.661 582.284 153.8C580.133 152.94 579.99 150.647 580.498 148.926C580.905 147.55 580.667 146.837 580.498 146.653H571.675C571.675 146.653 570.815 150.933 570.242 152.94C569.668 154.947 565.798 155.521 563.074 155.664C560.35 155.807 560.063 150.79 559.777 148.926C559.49 147.063 561.497 145.056 563.074 144.769C564.651 144.482 563.934 139.751 565.224 131.867Z",
    fill: "#732F3B",
    stroke: "#732F3B",
    strokeWidth: 0.286713,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.964 130.653C576.014 130.309 574.666 129.076 574.236 128.502C571.369 127.642 570.222 130.653 569.219 131.656C568.215 132.66 568.215 137.534 568.072 139.397C567.929 141.261 569.649 146.279 569.792 146.995C569.936 147.712 573.806 151.296 574.236 151.296C574.666 151.296 576.96 151.439 577.533 151.296C578.107 151.153 582.121 147.139 582.551 146.279C582.981 145.418 583.698 139.971 583.698 139.397C583.698 138.824 582.981 133.807 582.981 133.233C582.981 132.66 580.401 131.083 577.964 130.653Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.095 137.017C577.908 136.635 579.762 135.985 580.679 136.444C581.157 136.54 582.113 136.788 582.113 137.017M574.228 136.587C573.32 136.348 571.332 135.928 570.644 136.157C569.956 136.387 569.784 136.54 569.784 136.587",
    stroke: "black",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.099 138.241C578.673 137.907 580.049 137.496 580.966 138.528M570.645 137.955C571.218 137.62 572.594 137.209 573.512 138.241",
    stroke: "black",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.077,
    cy: 138.098,
    r: 0.573427,
    fill: "#0B0F21"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 579.532,
    cy: 138.385,
    r: 0.573427,
    fill: "#0B0F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.945 142.399C575.089 142.59 575.433 142.972 575.662 142.972C575.891 142.972 576.236 142.59 576.379 142.399",
    stroke: "black",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.081 145.553C574.228 145.983 576.092 146.499 577.812 146.269",
    stroke: "#732F3B",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.654 146.269C574.801 146.699 575.088 146.699 576.521 146.843",
    stroke: "#A34657",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 583.819,
    cy: 132.061,
    rx: 1.0035,
    ry: 1.72028,
    transform: "rotate(-28.6973 583.819 132.061)",
    fill: "#6668A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.271 132.441C622.074 130.721 625.046 130.004 626.432 129.861C629.013 129.247 634.46 132.441 635.033 133.445C635.607 134.448 635.177 139.179 635.32 140.326C635.464 141.473 634.46 144.627 634.46 146.06C634.46 147.494 630.733 150.361 630.159 150.934C629.586 151.508 626.862 151.364 625.715 150.934C624.568 150.504 621.271 146.347 620.985 145.343C620.698 144.34 620.124 139.323 620.268 138.319C620.411 137.316 620.268 134.592 621.271 132.441Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.982 143.976C627.221 144.215 627.842 144.549 628.416 143.976M629.563 139.675C629.993 139.245 631.225 138.643 632.716 139.675M625.262 139.675C624.832 139.197 623.685 138.528 622.538 139.675",
    stroke: "black",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.118 146.953C626.265 146.762 628.817 146.494 629.849 146.953",
    stroke: "#732F3B",
    strokeWidth: 0.573427,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 631.14,
    cy: 139.532,
    r: 0.573427,
    fill: "#0B0F21"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 623.972,
    cy: 139.532,
    r: 0.573427,
    fill: "#0B0F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.7 156.734C607.865 158.111 607.502 160.462 607.55 161.465V162.039C607.789 162.325 608.439 162.956 609.127 163.185C609.987 163.472 611.421 164.476 611.564 165.336C611.707 166.196 612.711 167.056 613.714 167.343C614.718 167.629 615.148 168.776 614.718 170.497C614.288 172.217 613.427 177.234 613.284 177.664C613.169 178.009 614.479 179.815 615.148 180.675V182.539C615.148 182.73 614.861 183.227 613.714 183.685C612.281 184.259 608.983 194.437 609.127 194.867C609.27 195.297 643.102 195.011 643.102 194.437C643.102 193.864 641.669 185.979 641.669 185.262C641.669 184.546 640.809 183.685 640.379 183.112C639.948 182.539 640.809 180.245 641.669 179.671C642.529 179.098 641.955 177.091 642.386 175.514C642.816 173.937 640.522 170.21 640.379 168.776C640.235 167.343 641.382 167.486 641.955 166.626C642.529 165.766 644.106 165.622 644.393 165.336C644.679 165.049 645.539 166.196 646.543 166.196C647.546 166.196 647.403 164.332 647.403 163.902C647.403 163.472 647.546 161.465 646.973 159.745C646.514 158.369 644.201 157.164 643.102 156.734C642.003 155.444 639.49 152.72 638.228 152.147C636.651 151.43 633.784 151.574 633.497 152.147C633.211 152.72 630.057 154.011 627.62 154.154C625.67 154.269 623.176 152.099 622.172 151C621.647 151.048 620.595 151.229 620.595 151.574C620.595 152.004 617.011 154.871 616.725 154.871C616.438 154.871 615.578 155.301 613.714 154.871C611.851 154.441 611.994 155.014 609.7 156.734Z",
    fill: "#454675"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.546 137.5C624.546 137.5 624.197 136.907 623.546 137C622.895 137.093 621.74 137.55 621.546 137.938M629.046 137.5C629.472 137.384 631.325 136.568 632.046 137C632.511 137.279 632.813 137.821 633.046 137.938",
    stroke: "black",
    strokeWidth: 0.465116,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.336 129.973C625.107 129.629 625.145 128.587 625.336 128.109C625.336 126.916 627.343 125.769 631.214 126.916C635.084 128.063 637.447 133.7 637.877 134.13C638.221 134.474 638.881 142.062 639.598 144.738C640.075 146.841 641.478 149.24 643.542 150.616C646.123 152.336 645.263 154.63 644.403 156.637C643.542 158.644 639.098 157.64 638.525 157.784C637.952 157.927 637.808 158.787 635.371 158.787C633.422 158.787 633.316 157.354 633.508 156.637C633.03 156.207 631.902 155.06 631.214 153.913C630.526 152.766 630.927 151.237 631.214 150.616C631.787 149.135 633.049 145.885 633.508 144.738C634.081 143.305 634.798 135.994 634.511 134.13C634.224 132.266 633.077 132.553 631.214 131.836C629.35 131.119 625.623 130.403 625.336 129.973Z",
    fill: "#732F3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.476 130.259L624.763 128.539C624.906 127.679 624.688 126.63 623.398 127.203C622.108 127.776 620.244 128.826 618.954 130.259C617.664 131.693 616.804 137.525 616.804 139.102C616.804 140.678 615.084 143.116 615.084 144.262C615.084 145.409 615.084 147.703 615.657 148.563C616.23 149.423 617.165 150.857 616.878 151.574C616.591 152.29 615.301 153.913 615.301 153.053C615.301 152.193 616.305 153.483 615.301 152.049C615.301 151.046 613.868 152.336 613.438 153.053C613.008 153.77 614.584 155.347 614.584 155.777C614.584 156.207 616.018 157.497 617.308 157.497C618.598 157.497 619.315 156.637 619.459 156.637C619.602 156.637 621.035 154.917 622.039 153.913C623.042 152.91 622.899 150.043 622.756 148.896C622.612 147.749 620.175 141.011 620.175 139.291C620.175 137.57 620.605 134.13 621.466 132.553C622.154 131.291 623.759 130.498 624.476 130.259Z",
    fill: "#732F3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.476 165.587C644.903 166.161 644.484 166.017 644.054 165.587C643.05 166.113 640.843 167.307 640.04 167.881C639.036 168.598 640.183 169.171 640.757 170.175C641.33 171.178 641.76 169.601 642.333 169.171C642.907 168.741 642.764 168.598 644.054 168.598C645.344 168.598 645.487 168.598 646.204 167.881C646.921 167.164 647.064 167.451 647.494 167.451C647.924 167.451 648.354 168.311 649.071 168.598C649.788 168.884 649.931 168.311 649.931 167.451C649.931 166.591 650.505 167.021 651.222 166.734C651.938 166.447 650.218 165.587 649.931 165.014C649.645 164.44 648.928 164.01 647.924 163.867C646.921 163.723 646.204 164.154 646.204 165.014C646.204 165.874 646.049 165.014 645.476 165.587Z",
    fill: "#8689CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.659 165.014C611.971 164.555 611.607 165.205 611.512 165.587C611.273 165.253 610.795 164.526 610.795 164.297C610.795 164.01 609.505 163.293 609.505 162.863C609.505 162.433 608.931 163.437 607.928 163.293C606.924 163.15 606.781 164.584 606.351 165.014C605.921 165.444 606.494 166.734 606.781 167.451C607.068 168.168 607.785 167.451 608.501 166.734C609.218 166.017 608.931 165.587 608.931 165.014C608.931 164.44 609.505 165.587 609.505 166.161C609.505 166.734 609.935 166.734 610.795 167.451C611.655 168.168 611.512 167.881 612.085 168.598C612.659 169.314 613.089 169.601 614.092 169.601C615.096 169.601 615.096 169.171 615.096 167.881C615.096 166.591 613.949 166.734 613.519 166.734C613.089 166.734 613.519 165.587 612.659 165.014Z",
    fill: "#8689CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.526 183.077C615.296 182.847 615.143 181.452 615.096 180.783C616.907 180.516 619.015 180.359 621.222 180.283C621.32 179.816 621.433 179.463 621.547 179.349C621.765 179.131 623.19 179.633 624.616 180.224C626.585 180.222 628.556 180.268 630.398 180.343C630.821 179.857 631.332 179.349 632.155 179.349C633.182 179.349 633.115 179.819 633.022 180.473C636.925 180.703 639.8 181.033 640.04 181.213C640.499 181.557 640.231 183.554 640.04 184.51C639.753 184.415 638.979 184.109 638.176 183.65C637.719 183.389 635.508 183.336 632.965 183.369C632.795 184.1 632.475 184.764 632.155 185.084C631.582 185.657 630.578 184.51 630.578 185.084V187.807C630.578 188.495 631.629 194.819 632.155 196.731C629.718 196.874 624.844 196.645 624.844 196.301C624.844 195.871 625.417 191.391 625.561 188.381C625.674 186.01 626.675 184.37 626.886 183.555C626.056 183.591 625.348 183.625 624.844 183.65C624.47 183.669 624.04 183.678 623.574 183.678C622.395 183.998 621.309 184.273 621.117 184.08C621.046 184.009 620.998 183.845 620.97 183.619C618.352 183.507 615.711 183.262 615.526 183.077Z",
    fill: "#8689CB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 635.14,
    cy: 133.494,
    rx: 1.0035,
    ry: 1.72028,
    transform: "rotate(-28.6973 635.14 133.494)",
    fill: "#6668A3"
  }))), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 668,
    y: 678,
    width: 81,
    height: 10,
    fill: "#5C393C"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 681,
    cy: 683,
    r: 7,
    fill: "#D38337"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 684,
    r: 10,
    fill: "#D38337"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M734.483 674C735.41 676.165 736 679.412 736 683.04C736 686.624 735.425 689.835 734.517 692C733.59 689.835 733 686.588 733 682.96C733 679.376 733.575 676.165 734.483 674Z",
    fill: "#0B0F21"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M683.483 674C684.41 675.805 685 678.51 685 681.534C685 684.52 684.425 687.196 683.517 689C682.59 687.196 682 684.49 682 681.466C682 678.48 682.575 675.804 683.483 674Z",
    fill: "#0B0F21"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M670.84 722.015C668.124 713.546 669.085 702.31 670.156 696.44C670.249 695.932 670.85 695.721 671.251 696.046L673.776 698.1C674.28 698.509 674.24 700.024 673.974 700.616C672.363 704.197 671.956 714.465 671.973 721.794C671.975 722.536 671.067 722.722 670.84 722.015Z",
    fill: "#C4C4C4"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M765.155 717.763C762.97 711.527 763.397 704.956 764.249 700.702C764.313 700.384 764.594 700.16 764.918 700.16H768.108C768.581 700.16 768.931 700.625 768.818 701.085C768.118 703.954 766.742 711.568 766.414 717.523C766.373 718.258 765.398 718.458 765.155 717.763Z",
    fill: "#C4C4C4"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M736.161 726.921C733.11 718.634 733.679 709.771 734.797 704.154C734.861 703.835 735.142 703.608 735.468 703.608H739.839C740.31 703.608 740.656 704.07 740.543 704.528C739.661 708.097 737.77 718.744 737.435 726.673C737.404 727.412 736.417 727.615 736.161 726.921Z",
    fill: "#C4C4C4"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M703.437 660.821C703.47 660.814 703.504 660.812 703.538 660.815L775.104 666.259C775.547 666.293 775.585 666.928 775.149 667.014L747.459 672.478C747.428 672.484 747.397 672.487 747.366 672.485L666.738 668.562C666.287 668.54 666.242 667.89 666.686 667.806L703.437 660.821L703.36 660.411L703.437 660.821Z",
    fill: "#8C6568",
    stroke: "#926E71",
    strokeWidth: 0.834369
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M665.602 682.368C665.648 681.462 666.456 680.778 667.363 680.877C698.192 684.244 716.555 685.111 747.898 684.929C748.809 684.923 749.542 685.685 749.497 686.59L748.583 704.725C748.539 705.597 747.797 706.268 746.926 706.224L666.187 702.156C665.316 702.112 664.645 701.37 664.689 700.499L665.602 682.368Z",
    fill: "#B09799",
    stroke: "#926E71",
    strokeWidth: 0.834369
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M666.649 668.614C666.699 667.615 667.663 666.891 668.656 667.109C672.008 667.846 678.502 669.098 685.74 669.568C688.855 669.771 690.544 669.588 692.796 669.344C692.908 669.332 693.022 669.319 693.138 669.307C695.551 669.047 698.717 668.735 704.957 668.735C711.179 668.735 714.905 669.379 718.276 670.065C718.65 670.141 719.019 670.217 719.387 670.294C722.356 670.909 725.252 671.509 729.557 671.655C737.811 671.933 745.143 671.406 748.751 671.071C749.739 670.979 750.586 671.783 750.537 672.764L750.019 683.051C749.966 684.098 748.927 684.818 747.919 684.504C743.484 683.12 734.081 680.389 728.021 680.083C720.766 679.718 715.01 680.543 709.583 681.32C708.099 681.533 706.639 681.742 705.181 681.922C698.391 682.761 691.549 682.99 682.122 680.101C679.917 679.425 677.292 679.323 674.809 679.472C672.319 679.622 669.94 680.027 668.21 680.387C667.121 680.613 666.087 679.754 666.142 678.676L666.649 668.614Z",
    fill: "#B09799",
    stroke: "#926E71",
    strokeWidth: 0.834369
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M750.338 672.426C750.389 671.695 750.936 671.096 751.659 670.977L777.196 666.8C778.195 666.637 779.087 667.442 779.028 668.452L777.274 698.222C777.233 698.922 776.736 699.511 776.053 699.668L750.048 705.683C749.013 705.923 748.041 705.093 748.115 704.033L750.338 672.426Z",
    fill: "#B09799",
    stroke: "#926E71",
    strokeWidth: 0.834369
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M709.846 562.761C709.873 562.325 710.082 561.914 710.42 561.637C734.174 542.106 763.772 549.083 786.098 568.343C786.292 568.51 786.393 568.761 786.371 569.016L777.861 665.217C777.824 665.645 777.453 665.967 777.023 665.944L704.501 662.034C704.058 662.011 703.72 661.63 703.747 661.187L709.846 562.761Z",
    fill: "#926E71"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M694.242 561.332C699.548 556.689 701.719 557.503 704.449 558.526C705.007 558.735 705.589 558.953 706.225 559.135C708.413 559.76 710.844 561.118 711.8 561.68C712.058 561.832 712.201 562.119 712.176 562.417L704.123 658.688V661.663C704.123 662.064 703.825 662.404 703.427 662.455L672.126 666.524C671.628 666.589 671.194 666.183 671.225 665.682L671.515 661.017C671.54 660.612 671.256 660.258 670.868 660.137C667.927 659.216 665.751 655.925 665.751 652.005C665.751 647.372 668.791 643.617 672.541 643.617C672.85 643.617 673.154 643.642 673.452 643.692C673.499 643.699 673.546 643.704 673.593 643.704H688.4C688.817 643.704 689.163 643.388 689.196 642.973C690.423 627.431 692.16 605.011 692.644 596.683C692.934 591.698 692.389 586.431 691.876 581.472C690.968 572.706 690.16 564.904 694.242 561.332Z",
    fill: "#B09799"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M775.578 562.484C780.774 558.01 788.701 564.938 790.279 566.412C790.459 566.581 790.539 566.822 790.508 567.067L778.068 665.201C778.016 665.617 777.65 665.921 777.232 665.898L775.507 665.802C775.05 665.777 774.664 666.141 774.664 666.6V667.98C774.664 668.421 774.307 668.779 773.865 668.779H757.098C756.872 668.779 756.689 668.596 756.689 668.37C756.689 668.131 756.485 667.943 756.247 667.962C756.087 667.975 755.925 667.988 755.762 668C751.255 668 746 661.669 746 659.53C746 649.725 753.544 649 758.05 649C759.403 649 760.679 649.316 761.802 649.876C762.32 650.135 762.983 649.868 763.093 649.3C765.985 634.47 770.077 612.89 771.584 602.029C772.514 595.321 772.418 588.473 772.331 582.345C772.201 573.093 772.094 565.485 775.578 562.484Z",
    fill: "#B09799"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M752.1 655.927C752.138 655.405 752.574 655 753.098 655H777C777.552 655 778 655.448 778 656V667.117C778 667.627 777.617 668.055 777.11 668.111L752.195 670.868C751.573 670.937 751.042 670.425 751.088 669.801L752.1 655.927Z",
    fill: "#B09799"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M643.277 746.105C632.242 746.105 623.342 757.914 602.042 757.914C579.375 757.914 561 751.933 561 744.556C561 739.019 571.35 734.269 586.096 732.243C591.975 730.23 581.908 728.47 581.908 726.358C581.908 718.981 600.283 713 622.95 713C645.617 713 663.992 718.981 663.992 726.358C663.992 728.104 662.963 729.771 661.092 731.3C656.441 733.715 677.543 735.736 677.543 740.297C677.543 745.322 668.876 749.396 658.184 749.396C651.963 749.396 647.923 746.105 643.277 746.105ZM639.086 738.798L638.895 738.67L639.146 738.635L639.086 738.798Z",
    fill: "#681D2A"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 11.6156,
    ry: 4.45265,
    transform: "matrix(1 0 0 -1 682.964 729.455)",
    fill: "#681D2A"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.13092,
    ry: 3.09749,
    transform: "matrix(1 0 0 -1 691.869 741.652)",
    fill: "#681D2A"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1043.83,
    y1: 460.751,
    x2: 1198.83,
    y2: 563.751,
    stroke: "#5D5E93",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3713_15982",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 27,
    width: 118,
    height: 151
  }, _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 27.0001,
    width: 118,
    height: 150.694,
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3713_15982)"
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M400.853 91.0733C403.296 89.9459 405.864 83.3069 406.49 80.1752C410.418 88.5038 418.421 88.5528 420.716 87.2466C420.966 86.2233 421.202 85.7155 421.334 86.3759C421.395 86.6834 421.165 86.991 420.716 87.2466C420.254 89.1351 419.743 92.7798 419.743 94.0797L411.663 97.0861C408.845 96.1466 399.261 91.8079 400.853 91.0733Z",
    fill: "#C4C4C4"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M417.986 56.7119C416.671 56.3361 413.665 56.0354 412.162 57.8392C410.283 60.094 408.779 61.2214 407.652 66.8584C406.75 71.3679 403.894 71.9942 402.579 71.7437C402.704 73.1216 404.761 78.8975 406.114 80.551C407.805 82.6179 404.389 87.3154 402.92 88.067C401.451 88.8185 397.095 89.9459 393.901 86.188C390.707 82.43 389.426 78.6959 390.929 77.9443C392.132 77.3431 391.555 77.4433 391.117 77.5685C390.24 76.4412 389.013 73.6978 391.117 71.7437C393.748 69.301 393.56 68.1736 394.499 66.8584C394.75 64.9167 395.815 60.3946 398.069 57.8392C400.888 54.645 402.015 52.9539 403.706 52.766C405.397 52.5781 409.531 49.008 416.483 51.6386C417.49 52.0196 418.241 52.3161 418.786 52.5431C420.306 52.1705 422.557 51.8872 423.436 52.766C424.751 54.0813 427.569 55.9603 427.193 59.5303C426.818 63.1004 427.757 66.2947 427.193 66.8584C426.743 67.3093 426.129 67.0463 425.878 66.8584C425.941 65.1673 425.841 61.5221 424.939 60.4698C423.811 59.1545 422.496 56.7119 420.241 56.7119H417.986Z",
    fill: "#454675"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M400.102 90.1347C401.304 90.285 406.365 93.4542 408.745 95.02C409.747 93.3916 411.977 90.1347 412.879 90.1347C414.006 90.1347 421.522 88.2557 424.904 86.7525C428.286 85.2493 430.917 88.6315 435.051 90.1347C439.184 91.6379 437.681 96.3353 438.057 98.2143C438.433 100.093 440.312 110.616 442.379 112.87C444.446 115.125 445.009 126.775 450.458 132.412C455.907 138.049 458.35 155.711 459.477 157.966C460.605 160.221 466.993 162.288 468.872 166.421C470.376 169.728 464.488 177.946 461.356 181.641H353.503C357.825 181.453 363.649 164.354 366.28 162.288C368.911 160.221 366.656 143.31 366.28 140.679C365.904 138.049 370.602 123.581 373.232 119.635C375.863 115.689 385.446 107.985 385.634 107.045C385.821 106.106 389.391 97.4627 392.022 95.02C394.653 92.5774 398.598 89.9468 400.102 90.1347Z",
    fill: "#454675"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M398.914 53.6443C402.753 50.2768 409.354 48.5143 412.899 49.6006C417.407 49.7072 421.509 49.3893 426.129 52.6938C430.75 55.9983 433.485 70.0621 435.672 72.9331C437.859 75.8041 442.651 87.7583 443.506 91.3496C444.361 94.9409 451.556 116.538 453.332 120.902C455.108 125.267 459.122 138.331 461.484 141.77C463.846 145.209 465.923 152.776 466.612 155.424C467.301 158.071 465.066 165.16 465.567 167.804C466.069 170.447 464.079 175.098 463.847 176.972C463.661 178.472 462.171 176.306 461.449 175.036C459.993 173.047 456.985 162.463 455.663 157.42L446.482 132.393C444.534 132.66 439.366 132.864 434.285 131.541C427.934 129.887 421.11 132.357 420.349 132.715C419.613 133.061 413.159 136.796 412.904 137.72C412.902 137.747 412.901 137.774 412.899 137.801C413.035 138.406 414.709 138.095 415.529 137.863C415.035 139.656 410.759 140.883 408.682 141.272C396.825 141.932 397.121 145.322 394.42 148.265C391.719 151.208 392.212 154.227 390.857 155.887C389.91 157.046 387.284 157.679 385.63 157.922C385.602 157.953 385.573 157.984 385.544 158.017C383.035 160.776 382.553 165.276 381.39 166.752C380.46 167.933 378.561 169.818 377.728 170.612C377.521 171.422 376.872 173.411 375.935 174.893C374.763 176.745 370.922 180.225 369.008 181.683C367.094 183.141 365.949 183.866 364.796 184.966C363.642 186.067 338.51 183.781 339.262 183.799C340.013 183.816 341.377 181.781 343.461 181.079C345.545 180.376 358.515 148.543 358.904 147.989C359.293 147.434 364.345 132.518 364.971 129.901C365.178 129.034 366.682 125.192 368.672 120.431C369.114 118.886 369.835 116.994 370.595 114.622C382.627 77.0337 389.385 74.6966 392.962 66.5114C396.538 58.3262 394.116 57.8537 398.914 53.6443Z",
    fill: "#454675",
    fillOpacity: 0.4
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M412.899 137.801C413.035 138.406 414.709 138.095 415.529 137.863C415.035 139.656 410.759 140.883 408.682 141.272C396.825 141.932 397.121 145.322 394.42 148.265C391.719 151.208 392.212 154.227 390.857 155.887C389.773 157.214 386.487 157.851 384.98 158.003C386.004 157.088 387.551 155.809 385.544 158.017C383.035 160.776 382.553 165.276 381.39 166.752C380.46 167.933 378.561 169.818 377.728 170.612C377.521 171.422 376.872 173.411 375.935 174.893C374.763 176.745 370.922 180.225 369.008 181.683C367.094 183.141 365.949 183.866 364.796 184.966C363.642 186.067 338.51 183.781 339.262 183.799C340.013 183.816 341.377 181.781 343.461 181.079C345.545 180.376 358.515 148.543 358.904 147.989C359.293 147.434 364.345 132.518 364.971 129.901C365.471 127.808 373.532 108.378 377.728 100.521C377.697 101.836 373.315 112.055 372.702 114.108C372.212 115.751 369.412 120.546 368.23 122.836C368.274 120.958 369.386 118.397 370.595 114.622C382.627 77.0337 389.385 74.6966 392.962 66.5114C396.538 58.3262 394.116 57.8537 398.914 53.6443C402.753 50.2768 409.354 48.5143 412.899 49.6006C417.407 49.7072 421.509 49.3893 426.129 52.6938C430.75 55.9983 433.485 70.0621 435.672 72.9331C437.859 75.8041 442.651 87.7583 443.506 91.3496C444.361 94.9409 451.556 116.537 453.332 120.902C455.108 125.267 459.122 138.331 461.484 141.77C463.846 145.209 465.923 152.776 466.612 155.424C467.301 158.071 465.066 165.16 465.567 167.804C466.069 170.447 464.079 175.098 463.847 176.972C463.661 178.472 462.171 176.306 461.449 175.036C459.993 173.047 456.985 162.463 455.663 157.42L446.482 132.393M412.899 137.801C412.729 137.045 419.589 133.073 420.349 132.715C421.11 132.357 427.934 129.887 434.285 131.541C439.366 132.864 444.534 132.66 446.482 132.393M412.899 137.801C413.206 132.521 413.008 119.797 412.008 111.203C410.759 100.46 409.536 88.5906 411.123 85.0571M446.482 132.393C443.292 124.461 436.559 105.92 435.145 95.2109C433.378 81.8246 426.854 63.627 426.129 62.4822M396.224 71.9999C393.329 85.5882 387.772 117.154 388.71 134.71",
    stroke: "black",
    strokeOpacity: 0.35,
    strokeWidth: 0.375796
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M430.615 150.139C430.624 150.13 430.633 150.121 430.642 150.112C434.014 146.842 441.134 138.977 442.863 133.449C444.596 127.906 439.449 103.412 438.057 98.965C439.671 101.816 448.978 114.982 450.27 118.131C451.677 122.37 452.512 137.89 453.089 140.491C453.809 143.741 446.142 154.434 445.966 157.021C445.79 159.608 438.999 165.302 439.095 163.899L439.375 159.775C435.941 148.639 432.142 148.681 430.642 150.112C430.633 150.121 430.624 150.13 430.615 150.139Z",
    fill: "#2E2F55"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M430.615 150.139C430.624 150.13 430.633 150.121 430.642 150.112C434.014 146.842 441.134 138.977 442.863 133.449C444.596 127.906 439.449 103.412 438.057 98.965C439.671 101.816 448.978 114.982 450.27 118.131C451.677 122.37 452.512 137.89 453.089 140.491C453.809 143.741 446.142 154.434 445.966 157.021C445.79 159.608 438.999 165.302 439.095 163.899L439.375 159.775C435.941 148.639 432.142 148.681 430.642 150.112C430.633 150.121 430.624 150.13 430.615 150.139Z",
    stroke: "#2E2F55",
    strokeWidth: 0.375796
  }))), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M430.166 153.604C431.819 151.199 434.112 151.224 435.051 151.537C436.053 151.6 438.17 152.928 438.621 157.738C438.872 158.489 439.523 160.18 440.124 160.932C440.876 161.872 437.682 164.502 435.051 164.917C434.221 165.048 437.019 162.242 436.178 162.663C435.427 163.038 432.233 165.63 432.233 164.502C432.233 163.6 434.299 161.535 434.675 160.408C433.736 161.311 431.857 163.751 430.166 163.938C427.535 163.938 428.099 162.811 429.79 162.059C431.143 161.458 432.358 158.489 432.984 157.738L430.542 158.717C430.542 159.28 429.79 160.556 429.414 160.932C429.038 161.308 427.535 161.496 427.535 160.932C427.535 160.368 428.099 156.61 430.166 153.604Z",
    fill: "#E8E0D4"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M430.542 158.717C430.542 159.28 429.79 160.556 429.414 160.932C429.038 161.308 427.535 161.496 427.535 160.932C427.535 160.368 428.099 156.61 430.166 153.604C431.819 151.199 434.112 151.224 435.051 151.537C436.053 151.6 438.17 152.928 438.621 157.738C438.872 158.489 439.523 160.18 440.124 160.932C440.876 161.872 437.682 164.502 435.051 164.917C434.221 165.048 437.019 162.242 436.178 162.663C435.427 163.038 432.233 165.63 432.233 164.502C432.233 163.6 434.299 161.535 434.675 160.408C433.736 161.311 431.857 163.751 430.166 163.938C427.535 163.938 428.099 162.811 429.79 162.059C431.143 161.458 432.358 158.489 432.984 157.738L430.542 158.717ZM430.542 158.717C430.542 158.153 431.481 156.798 432.608 156.423",
    stroke: "#CBBEAB",
    strokeWidth: 0.375796
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M424.875 58.3149C424.274 55.9098 420.866 56.1854 419.238 56.6238C418.361 56.1228 415.931 55.2334 413.225 55.6844C409.843 56.2481 409.092 59.4423 408.528 61.1334C407.964 62.8245 408.528 64.7035 407.4 67.1461C406.499 69.1003 404.144 70.0899 403.079 70.3404C399.509 69.4009 402.139 75.2258 402.515 76.5411C402.816 77.5933 404.269 77.8563 404.958 77.8563L407.4 81.4905C407.651 82.5553 412.654 87.2402 417.013 87.6912C422.462 88.2549 422.092 85.5536 422.462 84.8727C423.243 83.4337 424.028 82.43 424.529 81.8663C424.905 78.9852 425.1 77.2816 426.002 75.4778C427.13 73.223 426.566 69.2145 426.002 67.9619C425.752 67.7114 425.852 65.6054 426.002 64.7035C426.19 63.5761 425.627 61.3213 424.875 58.3149Z",
    fill: "#E8E0D4",
    fillOpacity: 0.8
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M415.134 81.4905C416.261 80.9894 418.629 80.0625 419.08 80.3631C419.643 80.7389 419.831 80.9268 420.207 80.9268C420.583 80.9268 420.771 80.3631 421.147 80.3631C421.522 80.3631 422.274 80.7389 422.462 80.9268M417.952 82.2421C418.391 82.6179 419.455 83.2567 420.207 82.8058C420.959 82.3548 421.147 82.1168 421.147 82.0542",
    stroke: "black",
    strokeWidth: 0.375796,
    strokeLinecap: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M424.905 65.7622C423.84 65.5743 421.485 65.7622 420.583 68.0169C419.681 70.2717 420.959 74.9065 421.898 76.0966",
    stroke: "black",
    strokeWidth: 0.375796
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M416.261 70.4046C415.572 69.4651 413.142 68.1498 408.933 70.4046M420.77 70.4046C421.021 69.1519 422.123 67.0224 424.528 68.5256",
    stroke: "black",
    strokeWidth: 0.375796,
    strokeLinecap: "round"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 412.503,
    cy: 70.0287,
    r: 0.93949,
    fill: "#0B0F21"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.273,
    cy: 69.2771,
    r: 0.93949,
    fill: "#0B0F21"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3713_15982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.898 76.0965C421.835 76.7229 421.71 77.036 420.958 77.2239C420.229 77.4062 420.019 77.2239 419.455 76.981C418.891 76.738 417.388 77.7326 417.2 76.981M416.825 68.1498C416.261 67.5234 414.607 66.3084 412.503 66.4587C410.398 66.609 408.87 68.0245 408.369 68.7135",
    stroke: "black",
    strokeWidth: 0.375796,
    strokeLinecap: "round"
  }))), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M401.639 105.228C400.073 98.8649 392.656 97.274 389.143 97.274C385.379 99.3251 377.188 106.999 374.538 121.287C371.226 139.147 376.195 149.053 377.55 156.107C378.905 163.161 386.884 172.466 385.228 183.122C384.174 185.974 395.165 183.422 397.122 183.122C399.08 182.822 405.554 175.918 409.017 170.065C412.48 164.211 421.061 159.559 423.019 158.658C424.585 157.938 420.961 153.255 418.954 151.004C418.201 148.653 416.575 143.5 416.093 141.699C415.491 139.448 409.318 126.24 408.113 123.839C406.909 121.437 403.596 113.183 401.639 105.228Z",
    fill: "#2E2F55"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M385.228 183.122C384.174 185.974 395.165 183.422 397.122 183.122C399.08 182.822 405.554 175.918 409.017 170.065C412.48 164.211 421.061 159.559 423.019 158.658C424.585 157.938 420.961 153.255 418.954 151.004C418.201 148.653 416.575 143.5 416.093 141.699C415.491 139.448 409.318 126.24 408.113 123.839C406.909 121.437 403.596 113.183 401.639 105.228C400.073 98.8649 392.656 97.274 389.143 97.274C385.379 99.3251 377.188 106.999 374.538 121.287C371.226 139.147 376.195 149.053 377.55 156.107C378.905 163.161 386.884 172.466 385.228 183.122ZM385.228 183.122C386.282 180.27 391.1 179.22 392.756 177.119C394.412 175.017 396.219 172.466 397.122 170.065",
    stroke: "#202143",
    strokeWidth: 0.375796,
    strokeLinecap: "round"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M420.025 171.104C419.667 170.141 416.799 166.888 415.41 165.383C414.099 164.66 410.894 168.494 409.455 170.502C408.264 173.272 410.546 176.474 411.837 177.729C410.646 181.222 412.928 181.694 414.219 181.493C415.171 182.818 416.501 182.447 417.047 182.096C419.429 183.903 420.322 182.447 420.471 181.493C421.166 182.146 422.704 183.059 423.3 181.493C424.044 179.536 420.471 172.309 420.025 171.104Z",
    fill: "#E8E0D4",
    stroke: "#DFCDB2",
    strokeWidth: 0.375796,
    strokeLinecap: "round"
  }))), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 67.0001,
    width: 107,
    height: 26,
    fill: "#C4C4C4"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.5,
    cy: 74.5001,
    rx: 33.5,
    ry: 10.5,
    fill: "#A8A8A8"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 281,
    cy: 85.5001,
    rx: 19,
    ry: 5.5,
    fill: "#A8A8A8"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 277.366,
    cy: 57.3809,
    rx: 11.5197,
    ry: 5.19514,
    fill: "#C4C4C4"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M272.698 71.2346C269.913 69.0511 266.374 61.9737 265.771 57.5315C266.449 52.7881 268.03 53.3151 269.009 50.7552C269.792 48.7073 267.177 46.4385 265.771 45.5601H288.811C287.004 46.2126 285.031 48.1652 285.573 50.7552C286.115 53.3452 288.811 54.2939 288.811 57.5315C288.269 63.4946 284.118 69.1515 282.11 71.2346C280.077 71.8369 275.074 73.0969 272.698 71.2346Z",
    fill: "#732F3B",
    stroke: "#732F3B",
    strokeWidth: 0.146429,
    strokeLinecap: "round"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 277.366,
    cy: 71.1593,
    rx: 4.74339,
    ry: 1.50584,
    fill: "#732F3B"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 277.29,
    cy: 45.1836,
    rx: 11.595,
    ry: 2.18347,
    fill: "#521C25"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.325,
    cy: 64.2324,
    r: 6.32452,
    fill: "#454675"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.607,
    cy: 66.6418,
    r: 6.02336,
    fill: "#BD7129"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 296.189,
    cy: 67.1688,
    r: 5.49631,
    fill: "#D38337"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.619,
    cy: 65.136,
    r: 9.48679,
    fill: "#BD7129"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.479,
    cy: 65.136,
    r: 9.48679,
    fill: "#D38337"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M277.218 70.5144C277.304 70.9527 277.447 71.5656 277.642 72.2783M280.133 78.4448C281.727 81.0493 283.289 81.5629 283.871 81.4942M280.133 78.4448C280.674 79.6452 281.738 82.3503 281.661 83.5676M280.133 78.4448C280.19 78.6372 279.867 79.0271 278.113 79.0473M280.133 78.4448C279.773 77.8563 279.442 77.2085 279.143 76.5401M279.143 76.5401C279.733 76.9927 281.132 77.8954 282.009 77.8853M279.143 76.5401C278.723 75.6036 278.365 74.6269 278.071 73.717M278.071 73.717C279.179 73.8056 281.57 73.8836 282.268 73.4866M278.071 73.717C277.908 73.2106 277.765 72.7249 277.642 72.2783M277.642 72.2783C277.453 73.1975 276.626 75.1693 274.837 75.703",
    stroke: "#732F3B",
    strokeWidth: 0.292857,
    strokeLinecap: "round"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.734,
    cy: 85.7296,
    rx: 3.61401,
    ry: 3.68931,
    transform: "rotate(-16.6063 280.734 85.7296)",
    fill: "#454675"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 284.086,
    cy: 77.7372,
    rx: 2.93639,
    ry: 3.01168,
    transform: "rotate(-16.6063 284.086 77.7372)",
    fill: "#313363"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.949,
    cy: 71.555,
    rx: 3.61401,
    ry: 3.68931,
    transform: "rotate(-16.6063 282.949 71.555)",
    fill: "#252757"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 290.73,
    cy: 77.0917,
    rx: 3.61401,
    ry: 3.68931,
    transform: "rotate(-16.6063 290.73 77.0917)",
    fill: "#252757"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.202,
    cy: 81.3117,
    rx: 3.61401,
    ry: 3.68931,
    transform: "rotate(-16.6063 269.202 81.3117)",
    fill: "#252757"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.134,
    cy: 82.2335,
    rx: 3.61401,
    ry: 3.68931,
    transform: "rotate(-16.6063 286.134 82.2335)",
    fill: "#454675"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 288.094,
    cy: 74.5779,
    rx: 3.16226,
    ry: 3.23755,
    transform: "rotate(-16.6063 288.094 74.5779)",
    fill: "#393B6A"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 291.742,
    cy: 70.7399,
    rx: 4.59281,
    ry: 4.6681,
    transform: "rotate(-16.6063 291.742 70.7399)",
    fill: "#454675"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.687,
    cy: 76.6586,
    rx: 3.61401,
    ry: 3.68931,
    transform: "rotate(-16.6063 272.687 76.6586)",
    fill: "#2B2D5B"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.063,
    cy: 76.7016,
    rx: 2.93639,
    ry: 3.01168,
    transform: "rotate(-16.6063 268.063 76.7016)",
    fill: "#454675"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.643,
    cy: 81.0409,
    rx: 4.14106,
    ry: 4.21635,
    transform: "rotate(-16.6063 275.643 81.0409)",
    fill: "#454675"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.832,
    cy: 75.6015,
    r: 5.6469,
    fill: "#454675"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M354.39 467.081L381.674 459.032C382.518 458.783 383.421 459.115 383.908 459.852L397.163 479.93C394.746 477.186 391.255 475.364 388.674 474.454C385.239 473.241 382.972 473.528 381.463 476.535C381.457 476.507 381.452 476.479 381.447 476.451C381.026 474.178 380.566 471.693 376.7 470.819C373.078 469.999 370.911 471.631 368.739 473.267C368.266 473.623 367.793 473.979 367.305 474.31C366.57 472.036 365.367 470.855 363.83 470.313C361.235 469.397 358.89 469.379 356.794 470.293C356.287 469.092 355.465 467.984 354.39 467.081Z",
    fill: "black"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M360.523 469.869L348.418 443.912C348.044 443.109 347.199 442.646 346.328 442.766L322.647 446.05C326.284 446.059 329.949 447.491 332.335 448.839C335.511 450.632 336.801 452.535 335.569 455.669C335.593 455.655 335.618 455.64 335.642 455.625C337.608 454.437 339.757 453.139 342.967 455.481C345.975 457.677 346.2 460.396 346.425 463.122C346.474 463.715 346.523 464.309 346.601 464.897C348.776 463.946 350.45 464.073 351.87 464.875C354.269 466.23 355.836 467.99 356.547 470.18C357.774 469.768 359.141 469.656 360.523 469.869Z",
    fill: "black"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M361.262 459.948C363.193 460.826 365.531 460.147 367.449 458.404C367.437 459.805 367.116 461.317 366.457 462.794C366.052 463.702 365.551 464.523 364.986 465.238L354.237 479.558C353.196 480.944 351.028 479.958 351.367 478.252L354.842 460.802C354.993 459.849 355.279 458.871 355.709 457.907C356.368 456.431 357.277 455.186 358.309 454.249C358.286 456.853 359.332 459.071 361.262 459.948Z",
    fill: "black"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M947.749 103.551C943.52 105.274 933.762 111.499 932 113V120H1011V107.5L1005.71 105.901C999.055 103.943 988.872 99.243 987.305 96.1098C985.739 92.9766 964.394 94.3474 964.003 95.3265C963.689 96.1098 960.739 98.2638 959.303 99.243C957.214 99.961 951.979 101.828 947.749 103.551Z",
    fill: "#454675"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M988.48 53.6163C991.744 55.9009 998.232 61.9584 998.076 67.9114C997.88 75.3526 997.88 73.9819 996.117 77.3108C994.355 80.6398 992.788 83.773 992.788 85.7312C992.788 87.6894 990.634 91.9975 987.893 91.9975C985.151 91.9975 986.522 95.5223 984.564 96.3056C983.99 96.5349 982.293 96.9993 980.06 97.3939C979.704 97.4798 979.363 97.535 979.035 97.5636C975.075 98.1751 969.876 98.4684 966.156 97.0379C964.81 96.5199 963.657 95.7759 962.827 94.739C958.178 88.9278 957.937 88.0986 956.605 83.5321L956.561 83.3813C955.19 78.6816 954.603 77.7025 954.799 75.1568C954.211 74.5041 953.036 72.8853 953.036 71.632C953.036 70.0654 953.624 69.0863 953.624 68.4988C953.624 67.9114 950.686 67.3239 951.861 66.149C953.036 64.974 954.211 64.3866 954.799 62.0367C955.386 59.6868 955.974 56.7495 955.778 55.1829C956.822 54.3996 959.107 53.1464 959.89 54.3996C960.869 55.9662 987.501 56.162 988.48 53.6163Z",
    fill: "#732F3B"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M966.156 97.0379C964.81 96.5199 963.657 95.7759 962.827 94.739C958.128 88.8644 957.932 88.0811 956.561 83.3813C955.19 78.6816 954.603 77.7025 954.799 75.1568C954.211 74.5041 953.036 72.8853 953.036 71.632C953.036 70.0654 953.624 69.0863 953.624 68.4988C953.624 67.9114 950.686 67.3239 951.861 66.149C953.036 64.974 954.211 64.3866 954.799 62.0367C955.386 59.6868 955.974 56.7495 955.778 55.1829C956.822 54.3996 959.107 53.1464 959.89 54.3996C960.869 55.9662 987.501 56.162 988.48 53.6163C991.744 55.9009 998.232 61.9584 998.076 67.9114C997.88 75.3526 997.88 73.9819 996.117 77.3108C994.355 80.6398 992.788 83.773 992.788 85.7312C992.788 87.6894 990.634 91.9975 987.893 91.9975C985.151 91.9975 986.522 95.5223 984.564 96.3056C983.99 96.5349 982.293 96.9993 980.06 97.3939M966.156 97.0379C967.704 97.0936 970.711 96.6123 973.611 94.739M966.156 97.0379C970.207 98.5957 976.012 98.1093 980.06 97.3939M973.611 94.739C974.259 95.9867 976.457 98.2645 980.06 97.3939M973.611 94.739C974.699 94.0362 975.772 93.1374 976.746 91.9975M963.807 85.7312C965.7 88.7338 971.091 93.9949 977.514 91.0184C977.266 91.363 977.01 91.6891 976.746 91.9975M976.746 91.9975C978.569 92.7155 982.997 92.4675 986.13 85.7312",
    stroke: "#59242E",
    strokeWidth: 0.78329,
    strokeLinecap: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M976.663 45.1773C968.204 43.7674 962.042 51.1173 960.019 54.9684C956.102 61.6264 958.648 70.2426 960.019 75.9214C961.389 81.6003 964.131 90.4123 975.88 90.4123C987.63 90.4123 987.434 80.817 991.35 70.6342C995.267 60.4515 991.35 54.9684 989 49.6812C987.12 45.4514 979.992 44.9162 976.663 45.1773Z",
    fill: "#732F3B"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M976.663 47.35C975.403 52.0497 973.181 62.7808 974.381 68.1072M974.381 49.6812C970.615 50.0791 962.471 52.4414 960.019 58.7077M976.663 49.6812C980.45 50.2749 988.506 52.3239 990.438 55.7704M960.019 54.9684C962.042 51.1173 968.204 43.7674 976.663 45.1773C979.992 44.9162 987.12 45.4514 989 49.6812C991.35 54.9684 995.267 60.4515 991.35 70.6342C987.434 80.817 987.63 90.4123 975.88 90.4123C964.131 90.4123 961.389 81.6003 960.019 75.9214C958.648 70.2426 956.102 61.6264 960.019 54.9684Z",
    stroke: "#59242E",
    strokeWidth: 0.78329,
    strokeLinecap: "round"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M983.666 79.2614C984.026 78.2721 985.187 76.3302 986.953 76.4759C988.001 76.5624 988.453 76.5997 988.609 76.6125C988.609 76.6125 988.609 76.6125 988.609 76.6125C988.684 76.6187 988.716 76.6214 988.609 76.6125C988.901 77.5629 988.825 79.7148 986.186 80.7197C983.547 81.7246 983.407 80.1662 983.666 79.2614Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M980.005 79.6709C980.798 78.9783 982.752 77.8381 984.228 78.8187C985.104 79.4003 985.482 79.6513 985.612 79.738C985.612 79.738 985.612 79.738 985.612 79.7379C985.675 79.7795 985.702 79.7974 985.612 79.738C985.409 80.7112 984.304 82.5591 981.507 82.1646C978.711 81.77 979.341 80.3378 980.005 79.6709Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M975.201 80.1621C976.115 79.6399 978.256 78.9088 979.51 80.1621C980.253 80.9054 980.574 81.2263 980.685 81.337C980.685 81.337 980.685 81.337 980.685 81.337C980.738 81.3901 980.76 81.413 980.685 81.337C980.293 82.2508 978.844 83.8435 976.181 82.9036C973.517 81.9636 974.418 80.6843 975.201 80.1621Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M971.306 79.4624C972.247 79.1059 974.38 78.7364 975.375 80.1108C975.965 80.926 976.219 81.2778 976.307 81.3993C976.307 81.3993 976.307 81.3993 976.307 81.3993C976.349 81.4575 976.368 81.4826 976.307 81.3993C975.8 82.2049 974.191 83.4937 971.817 82.2036C969.443 80.9135 970.487 79.8386 971.306 79.4624Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M967.368 79.3788C968.282 78.8566 970.423 78.1256 971.677 79.3788C972.42 80.1222 972.741 80.443 972.851 80.5537C972.851 80.5537 972.851 80.5537 972.851 80.5537C972.905 80.6069 972.927 80.6297 972.851 80.5537C972.46 81.4676 971.011 83.0603 968.348 82.1203C965.684 81.1804 966.585 79.901 967.368 79.3788Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M961.606 80.4133C960.65 79.7909 960.623 78.0613 960.729 77.2743C960.717 77.1588 960.798 76.9454 961.219 77.0154C961.567 77.0509 962.051 77.1533 962.551 77.3477C963.902 77.1753 966.891 77.493 968.042 80.1426C967.288 80.9555 965.272 82.1521 963.239 80.4351C962.67 80.6476 962.07 80.7152 961.606 80.4133Z",
    fill: "#6A2834"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M962.551 77.3477C962.051 77.1533 961.567 77.0509 961.219 77.0154C960.798 76.9454 960.717 77.1588 960.729 77.2743C960.623 78.0613 960.65 79.7909 961.606 80.4133C962.07 80.7152 962.67 80.6476 963.239 80.4351M962.551 77.3477C963.478 77.708 964.461 78.3843 964.745 79.5365C964.411 79.8205 963.842 80.2094 963.239 80.4351M962.551 77.3477C963.902 77.1753 966.891 77.493 968.042 80.1426C967.288 80.9555 965.272 82.1521 963.239 80.4351",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M983.287 81.8916C983.623 81.0236 984.707 79.3195 986.358 79.4474C987.337 79.5233 987.76 79.556 987.906 79.5673C987.906 79.5673 987.906 79.5673 987.906 79.5673C987.976 79.5727 988.006 79.5751 987.906 79.5673C988.179 80.4013 988.108 82.2896 985.641 83.1713C983.175 84.0531 983.044 82.6856 983.287 81.8916Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M979.865 82.251C980.605 81.6432 982.432 80.6427 983.812 81.5032C984.63 82.0135 984.983 82.2338 985.105 82.3098C985.105 82.3098 985.105 82.3098 985.105 82.3098C985.164 82.3463 985.189 82.362 985.105 82.3098C984.915 83.1639 983.882 84.7854 981.269 84.4392C978.655 84.093 979.244 82.8362 979.865 82.251Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M975.376 82.682C976.23 82.2238 978.231 81.5823 979.402 82.682C980.097 83.3343 980.397 83.6159 980.5 83.713C980.5 83.713 980.5 83.713 980.5 83.713C980.55 83.7596 980.571 83.7797 980.5 83.713C980.134 84.5149 978.78 85.9125 976.291 85.0877C973.802 84.2629 974.643 83.1403 975.376 82.682Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M971.734 82.0681C972.615 81.7552 974.608 81.431 975.538 82.637C976.089 83.3524 976.327 83.6611 976.409 83.7677C976.409 83.7677 976.409 83.7677 976.409 83.7677C976.449 83.8188 976.466 83.8408 976.409 83.7677C975.935 84.4746 974.431 85.6056 972.213 84.4735C969.994 83.3414 970.969 82.3982 971.734 82.0681Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M968.054 81.9947C968.908 81.5365 970.909 80.895 972.081 81.9947C972.775 82.647 973.075 82.9285 973.179 83.0257C973.179 83.0257 973.179 83.0257 973.179 83.0257C973.228 83.0723 973.25 83.0924 973.179 83.0257C972.813 83.8276 971.458 85.2252 968.969 84.4004C966.48 83.5756 967.322 82.453 968.054 81.9947Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M962.668 82.9024C961.775 82.3563 961.749 80.8386 961.848 80.148C961.837 80.0467 961.912 79.8594 962.306 79.9208C962.631 79.9519 963.083 80.0418 963.551 80.2124C964.814 80.0611 967.607 80.3399 968.683 82.6649C967.979 83.3782 966.095 84.4282 964.194 82.9215C963.662 83.1081 963.101 83.1673 962.668 82.9024Z",
    fill: "#6A2834"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M963.551 80.2124C963.083 80.0418 962.631 79.9519 962.306 79.9208C961.912 79.8594 961.837 80.0467 961.848 80.148C961.749 80.8386 961.775 82.3563 962.668 82.9024C963.101 83.1673 963.662 83.1081 964.194 82.9215M963.551 80.2124C964.417 80.5285 965.337 81.122 965.602 82.133C965.29 82.3822 964.758 82.7235 964.194 82.9215M963.551 80.2124C964.814 80.0611 967.607 80.3399 968.683 82.6649C967.979 83.3782 966.095 84.4282 964.194 82.9215",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M983.599 74.2106C984.095 75.1385 985.521 76.8954 987.248 76.4996C988.273 76.2648 988.715 76.1634 988.868 76.1285C988.868 76.1285 988.868 76.1285 988.868 76.1285C988.941 76.1117 988.973 76.1045 988.868 76.1285C989.022 75.1462 988.64 73.027 985.885 72.4083C983.129 71.7896 983.213 73.352 983.599 74.2106Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M979.614 73.5846C980.406 74.2772 982.36 75.4174 983.836 74.4368C984.712 73.8552 985.09 73.6042 985.221 73.5175C985.221 73.5175 985.221 73.5175 985.221 73.5175C985.283 73.476 985.31 73.4581 985.221 73.5175C985.017 72.5443 983.912 70.6964 981.116 71.0909C978.319 71.4854 978.949 72.9177 979.614 73.5846Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M975.176 73.6451C976.08 74.1948 978.198 74.9644 979.438 73.6451C980.173 72.8626 980.49 72.5249 980.6 72.4083C980.6 72.4083 980.6 72.4083 980.6 72.4083C980.652 72.3524 980.675 72.3283 980.6 72.4083C980.212 71.4463 978.779 69.7697 976.145 70.7592C973.51 71.7486 974.401 73.0954 975.176 73.6451Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M972.072 74.155C973.014 74.5115 975.146 74.8809 976.141 73.5066C976.731 72.6914 976.986 72.3396 977.074 72.2181C977.074 72.2181 977.074 72.2181 977.074 72.2181C977.116 72.1599 977.134 72.1348 977.074 72.2181C976.566 71.4124 974.957 70.1236 972.584 71.4138C970.21 72.7039 971.254 73.7788 972.072 74.155Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M967.735 74.0367C968.639 74.5864 970.757 75.356 971.996 74.0367C972.732 73.2542 973.049 72.9165 973.158 72.7999C973.158 72.7999 973.158 72.7999 973.158 72.7999C973.211 72.744 973.234 72.7199 973.158 72.7999C972.771 71.8379 971.338 70.1613 968.703 71.1508C966.069 72.1402 966.96 73.487 967.735 74.0367Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M961.605 72.8468C960.648 73.4638 960.612 75.1653 960.714 75.9389C960.701 76.0525 960.78 76.2621 961.201 76.1911C961.549 76.1545 962.032 76.0513 962.533 75.8576C963.881 76.0203 967.932 75.4589 969.094 72.8467C968.346 72.0509 965.274 71.1179 963.235 72.8171C962.668 72.6109 962.069 72.5474 961.605 72.8468Z",
    fill: "#6A2834"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M962.533 75.8576C962.032 76.0513 961.549 76.1545 961.201 76.1911C960.78 76.2621 960.701 76.0525 960.714 75.9389C960.612 75.1653 960.648 73.4638 961.605 72.8468C962.069 72.5474 962.668 72.6109 963.235 72.8171M962.533 75.8576C963.46 75.4985 964.446 74.8283 964.735 73.6935C964.403 73.4158 963.837 73.036 963.235 72.8171M962.533 75.8576C963.881 76.0203 967.932 75.4589 969.094 72.8467C968.346 72.0509 965.274 71.1179 963.235 72.8171",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M983.599 72.2523C984.095 73.1802 985.521 74.9371 987.248 74.5413C988.273 74.3065 988.715 74.2051 988.868 74.1701C988.868 74.1701 988.868 74.1701 988.868 74.1702C988.941 74.1534 988.973 74.1461 988.868 74.1701C989.022 73.1879 988.64 71.0687 985.885 70.45C983.129 69.8313 983.213 71.3937 983.599 72.2523Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M979.614 71.6263C980.406 72.319 982.36 73.4591 983.836 72.4786C984.712 71.897 985.09 71.6459 985.221 71.5593C985.221 71.5593 985.221 71.5593 985.221 71.5593C985.283 71.5177 985.31 71.4998 985.221 71.5593C985.017 70.586 983.912 68.7382 981.116 69.1327C978.319 69.5272 978.949 70.9595 979.614 71.6263Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M975.176 71.6868C976.08 72.2365 978.198 73.0061 979.438 71.6868C980.173 70.9043 980.49 70.5666 980.6 70.45C980.6 70.45 980.6 70.45 980.6 70.45C980.652 70.3941 980.675 70.37 980.6 70.45C980.212 69.488 978.779 67.8115 976.145 68.8009C973.51 69.7904 974.401 71.1371 975.176 71.6868Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M972.072 72.1967C973.014 72.5532 975.146 72.9227 976.141 71.5483C976.731 70.7331 976.986 70.3813 977.074 70.2598C977.074 70.2599 977.074 70.2599 977.074 70.2599C977.116 70.2016 977.134 70.1765 977.074 70.2598C976.566 69.4542 974.957 68.1654 972.584 69.4555C970.21 70.7457 971.254 71.8205 972.072 72.1967Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M967.735 72.0784C968.639 72.6281 970.757 73.3977 971.996 72.0784C972.732 71.2959 973.049 70.9582 973.158 70.8416C973.158 70.8416 973.158 70.8416 973.158 70.8416C973.211 70.7857 973.234 70.7616 973.158 70.8416C972.771 69.8796 971.338 68.2031 968.703 69.1925C966.069 70.182 966.96 71.5287 967.735 72.0784Z",
    fill: "#6A2834",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M961.605 70.8885C960.648 71.5056 960.612 73.207 960.714 73.9807C960.701 74.0943 960.78 74.3038 961.201 74.2329C961.549 74.1962 962.032 74.0931 962.533 73.8993C963.881 74.0621 967.932 73.5006 969.094 70.8885C968.346 70.0926 965.274 69.1596 963.235 70.8589C962.668 70.6526 962.069 70.5892 961.605 70.8885Z",
    fill: "#6A2834"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M962.533 73.8993C962.032 74.0931 961.549 74.1962 961.201 74.2329C960.78 74.3038 960.701 74.0943 960.714 73.9807C960.612 73.207 960.648 71.5056 961.605 70.8885C962.069 70.5892 962.668 70.6526 963.235 70.8589M962.533 73.8993C963.46 73.5402 964.446 72.87 964.735 71.7352C964.403 71.4575 963.837 71.0778 963.235 70.8589M962.533 73.8993C963.881 74.0621 967.932 73.5006 969.094 70.8885C968.346 70.0926 965.274 69.1596 963.235 70.8589",
    stroke: "#59242E",
    strokeWidth: 0.78329
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M676.5 51.5001C676.5 60.3697 668.692 68.8706 654.962 75.2418C641.358 81.5551 622.457 85.5001 601.5 85.5001C580.543 85.5001 561.642 81.5551 548.038 75.2418C534.308 68.8706 526.5 60.3697 526.5 51.5001C526.5 42.6305 534.308 34.1296 548.038 27.7585C561.642 21.4452 580.543 17.5001 601.5 17.5001C622.457 17.5001 641.358 21.4452 654.962 27.7585C668.692 34.1296 676.5 42.6305 676.5 51.5001Z",
    fill: "#454675",
    stroke: "#2A2C51",
    strokeWidth: 3
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M610.045 55.2012C615.337 51.2627 631.268 40.9797 633.475 35.389C634.062 36.5877 630.433 46.4049 622.737 49.5825C626.966 50.6868 636.286 53.0544 639.73 53.6896C644.035 54.4835 651.595 55.03 654.022 51.8797C656.449 48.7295 659.794 43.0172 653.953 36.9986C656.046 36.9889 659.987 39.4122 659.009 49.1827C660.524 49.9121 664.809 49.5154 666.878 41.2407C668.362 35.3045 667.762 31.2381 664.478 24.9751C659.986 16.4087 666.094 22.4099 666.799 24.0343C667.504 25.6587 672.422 33.3093 671.058 40.0588C670.719 41.7371 670.458 42.8445 670.259 43.5458C672.73 41.4984 677.211 37.4527 679.17 34.4408C678.22 38.3593 674.74 46.9012 668.428 49.7206L664.61 53.5748C661.601 56.6115 651.614 59.2153 643.593 59.3686C635.572 59.5218 630.928 56.336 626.158 55.7767C621.389 55.2174 615.331 57.0574 612.553 59.8605C609.776 62.6635 611.441 55.1948 610.045 55.2012Z",
    fill: "#D38337",
    stroke: "#B76F2B",
    strokeWidth: 0.567239
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M659.003 35.4058C656.429 41.9283 645.818 50.348 640.834 53.7426C642.698 54.4781 646.069 54.2998 647.521 54.1187C657.986 44.2115 659.536 37.5154 659.003 35.4058Z",
    fill: "#D38337",
    stroke: "#B76F2B",
    strokeWidth: 0.567239
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M593.955 54.0371C588.663 50.0985 572.732 39.8156 570.525 34.2248C569.938 35.4235 573.567 45.2408 581.263 48.4183C577.034 49.5227 567.714 51.8902 564.27 52.5254C559.965 53.3194 552.405 53.8658 549.978 50.7156C547.551 47.5653 544.206 41.8531 550.047 35.8344C547.954 35.8247 544.013 38.2481 544.991 48.0185C543.476 48.7479 539.191 48.3512 537.122 40.0765C535.638 34.1403 536.238 30.0739 539.522 23.8109C544.014 15.2445 537.906 21.2457 537.201 22.8701C536.496 24.4945 531.578 32.1451 532.942 38.8946C533.281 40.5729 533.542 41.6803 533.741 42.3816C531.27 40.3342 526.789 36.2885 524.83 33.2766C525.78 37.1951 529.26 45.737 535.572 48.5564L539.39 52.4107C542.399 55.4473 552.386 58.0511 560.407 58.2044C568.428 58.3576 573.072 55.1718 577.842 54.6125C582.611 54.0532 588.669 55.8932 591.447 58.6963C594.224 61.4994 592.559 54.0306 593.955 54.0371Z",
    fill: "#D38337",
    stroke: "#B76F2B",
    strokeWidth: 0.567239
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M544.997 34.2416C547.571 40.7641 558.182 49.1839 563.166 52.5784C561.302 53.3139 557.931 53.1356 556.479 52.9545C546.014 43.0473 544.464 36.3512 544.997 34.2416Z",
    fill: "#D38337",
    stroke: "#B76F2B",
    strokeWidth: 0.567239
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M599.057 57.0099C598.136 57.9306 596.81 54.8725 596.262 53.2283C589.883 54.7409 588.014 58.243 587.877 59.805C588.425 59.805 589.702 59.8872 590.425 60.216C591.149 60.5449 591.275 63.5866 591.247 65.0663C591.165 64.7375 590.179 64.5731 589.521 64.5731C588.863 64.5731 586.89 66.8749 586.644 70.1633C586.397 73.4516 587.877 76.74 588.617 77.3976C589.209 77.9238 590.069 77.6168 590.425 77.3976C590.82 77.9238 592.179 87.5915 592.809 92.3596C593.138 93.6091 595.851 94.6888 597.166 95.0725C596.673 97.7853 598.399 101.896 599.057 104.444C599.715 106.993 601.688 107.157 602.181 107.157C602.674 107.157 602.756 104.362 602.921 104.444C603.085 104.526 602.181 105.349 604.401 106.91C606.176 108.16 608.593 99.5391 609.58 95.0725C611.092 94.4806 612.512 92.798 613.033 92.0307C612.769 90.3208 614.512 81.1244 615.417 76.74C615.663 76.9318 616.272 77.2661 616.732 77.0688C617.307 76.8222 618.047 72.9584 618.047 70.1633C618.047 67.3682 615.006 64.5731 614.512 64.2443C614.019 63.9154 614.595 60.1338 615.828 59.805C616.814 59.5419 617.006 59.6954 616.979 59.805C618.129 57.6676 609.58 52.4062 609.909 53.2283C610.172 53.886 608.155 55.4753 607.114 56.1878C604.812 57.6676 604.154 55.6946 602.839 54.7081C601.523 53.7216 600.208 55.859 599.057 57.0099Z",
    fill: "#E8E0D4"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M598.579 96.4517C598.71 99.0166 600.826 102.289 601.867 103.604C602.853 104.996 601.867 97.356 602.525 96.4517C603.182 95.5475 602.853 97.4382 603.1 97.9315C603.347 98.4247 603.347 97.1916 603.758 96.4517C604.169 95.7119 603.347 103.604 604.169 103.604C604.991 103.604 607.128 97.4382 607.457 94.8898C607.786 92.3413 606.388 91.1904 605.813 89.9573C605.237 88.7241 605.237 91.437 604.169 91.8481C603.1 92.2591 604.004 91.026 604.169 89.9573C604.333 88.8885 602.689 89.875 601.867 89.2996C601.045 88.7241 601.867 91.026 600.88 91.8481C599.894 92.6701 600.14 90.6971 599.894 89.2996C599.647 87.9021 598.414 93.2456 598.579 96.4517Z",
    fill: "#0B0F21",
    stroke: "black",
    strokeWidth: 0.18908
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M592.069 71.3964C592.069 74.2567 591.411 77.0688 589.849 76.2467C588.487 76.2467 587.383 73.9279 587.383 71.0675C588.123 67.9436 588.651 66.4639 590.013 66.4639C591.164 67.286 592.644 68.0258 592.069 71.3964Z",
    fill: "#0B0F21"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M617.307 70.0811C617.061 72.7118 618.211 73.5339 615.91 75.8357C613.608 76.5756 613.073 73.8218 612.704 70.9854C612.334 68.149 612.128 66.6284 614.163 65.5492C615.17 64.7376 616.567 68.2725 617.307 70.0811Z",
    fill: "#0B0F21"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M598.646 73.205C598.4 74.0545 598.054 76.0658 598.646 77.3154C599.386 78.8774 600.044 79.7817 600.044 80.3571C600.044 80.9326 599.715 87.4271 600.373 86.7694C601.03 86.1117 601.606 84.2209 601.935 84.7964C602.263 85.3719 602.674 86.1117 602.757 85.4541C602.839 84.7964 603.085 81.3436 602.757 80.3571C602.428 79.3706 602.263 78.1375 602.757 76.4933C603.25 74.8492 603.661 72.3007 603.003 71.232C602.346 70.1633 603.743 67.286 603.496 66.7927C603.359 67.3134 603.168 68.7164 603.496 70.1633C603.908 71.9719 604.154 73.9449 603.825 74.6847C603.496 75.4246 602.757 77.562 603.003 78.6308C603.25 79.6995 603.496 83.4811 603.496 84.1387C603.496 84.7964 603.332 85.2074 603.825 84.7964C604.319 84.3854 604.483 83.9743 604.647 84.3854C604.812 84.7964 605.058 85.7007 605.141 85.9473C605.223 86.1939 605.881 86.1117 605.963 85.1252C606.045 84.1387 605.881 82.0835 606.292 80.6038C606.703 79.124 607.114 77.8087 607.525 78.2197",
    stroke: "black",
    strokeWidth: 0.567239,
    strokeLinecap: "round"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M609.168 51.72C609.431 51.2596 610.593 51.9118 611.141 52.2954C612.21 53.0353 614.676 54.7617 615.991 55.7482C618.112 57.3388 617.636 58.7899 617.718 59.6942C617.8 60.5985 616.649 61.1739 616.649 60.1874C616.649 59.2009 610.155 54.104 609.168 53.3641C608.182 52.6242 608.839 52.2954 609.168 51.72Z",
    fill: "#C0BAB0"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M595.028 51.5555C596.146 51.0294 596.426 52.1584 596.426 52.7887C596.497 53.3641 595.521 53.8574 594.042 54.7617C592.562 55.666 591.329 57.5568 590.342 58.2144C589.356 58.8721 588.698 60.1874 587.629 60.1874C586.561 60.1874 588.863 56.9813 589.356 56.2414C589.849 55.5015 593.631 52.2132 595.028 51.5555Z",
    fill: "#C0BAB0"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 615,
    cy: 56.5001,
    rx: 1,
    ry: 1.5,
    fill: "#D38337"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 590,
    cy: 57.5001,
    rx: 1,
    ry: 1.5,
    fill: "#D38337"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3713_15982",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 727,
    y: 29,
    width: 146,
    height: 154
  }, _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 727,
    y: 29.0001,
    width: 146,
    height: 153,
    fill: "#C4C4C4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3713_15982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M811.09 117.152C809.624 115.442 808.443 101.68 808.036 95.0131C797.704 101.68 777.377 115.686 778.721 118.373C780.4 121.732 777.499 140.207 778.721 144.177C779.942 148.146 812.922 119.29 811.09 117.152Z",
    fill: "#A5A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.311 43.2347C787.677 42.624 768.147 47.7524 765.582 54.5926C762.376 63.1428 763.903 76.4262 763.445 78.1057C762.987 79.7852 760.696 83.6022 762.071 86.1978C763.445 88.7934 764.972 98.5651 766.498 99.9392C768.025 101.313 773.369 110.627 773.827 112.765C774.285 114.902 777.95 119.483 779.324 120.093C780.698 120.704 789.706 123.605 794.134 117.345C798.562 111.085 801.615 112.459 806.348 102.688C808.545 98.1531 809.066 95.6256 808.909 94.3123C809.813 94.8809 811.155 94.7218 812.761 92.1524C815.357 87.572 817.952 87.572 818.105 82.8388C818.258 78.1057 816.273 75.9681 815.051 75.6628C813.83 75.3574 807.875 79.1744 807.875 81.4647C806.857 73.5252 805.127 57.2187 806.348 55.5087C810.208 50.1054 800.93 43.3688 795.311 43.2347Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.602 76.2535C781.48 75.3985 782.569 73.4543 783.129 72.5891C784.656 71.0623 788.778 71.8257 790 71.5204C791.221 71.215 796.107 74.4213 797.329 75.9481C798.55 77.475 798.55 78.8491 797.481 81.9028C796.412 84.9564 790 84.0403 788.778 83.8876C787.557 83.7349 785.877 80.2233 784.961 79.6125C784.045 79.0018 781.755 77.3223 781.602 76.2535Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.869 75.0321C776.991 72.7113 775.393 72.4365 774.579 72.5891C771.373 71.673 766.639 73.3526 766.181 73.5052C765.723 73.6579 766.334 77.3223 764.96 78.8491C763.586 80.3759 765.113 83.1242 767.403 84.3457C769.693 85.5671 774.579 82.5135 775.648 81.9028C776.716 81.292 776.716 77.933 776.869 75.0321Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.958 74.2483C777.347 77.8618 776.065 85.5468 775.82 87.379C775.515 89.6692 774.294 92.8755 776.126 93.3336C777.958 93.7916 779.179 93.4863 779.637 92.8755C780.095 92.2648 781.47 91.5014 782.386 91.8068C783.302 92.1121 784.676 93.4863 784.676 94.097C784.676 94.7077 786.05 95.0131 786.355 94.555",
    stroke: "#A0A0A0",
    strokeWidth: 0.371287
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.523 93.9142C782.813 91.1048 781.317 91.5014 779.943 92.5702C779.943 93.7916 780.859 93.1508 782.691 93.9142C784.157 94.5249 784.523 94.1686 784.523 93.9142Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.35901,
    transform: "matrix(-1 0 0 1 789.714 76.9966)",
    fill: "#E8E0D4"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.67951,
    transform: "matrix(-1 0 0 1 789.867 77.1492)",
    fill: "#8B8CBB"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.458047,
    transform: "matrix(-1 0 0 1 789.867 77.1492)",
    fill: "#454675"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.458047,
    transform: "matrix(-1 0 0 1 789.867 77.1492)",
    fill: "#454675"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.05365,
    transform: "matrix(-1 0 0 1 772.003 77.6074)",
    fill: "#E8E0D4"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.67951,
    transform: "matrix(-1 0 0 1 771.545 77.4547)",
    fill: "#8B8CBB"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.458047,
    transform: "matrix(-1 0 0 1 771.239 77.1493)",
    fill: "#454675"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.458047,
    transform: "matrix(-1 0 0 1 771.239 77.1493)",
    fill: "#454675"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.54751,
    transform: "matrix(-1 0 0 1 787.73 78.0654)",
    stroke: "black",
    strokeWidth: 0.371287
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.54751,
    transform: "matrix(-1 0 0 1 771.24 78.3707)",
    stroke: "black",
    strokeWidth: 0.371287
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.606 76.2331C782.741 75.6733 780.492 74.6147 778.415 74.859C776.339 75.1033 775.514 75.8769 775.362 76.2331",
    stroke: "black",
    strokeWidth: 0.371287
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.844 95.4865C781.256 94.9979 779.637 95.6901 779.027 96.0973C778.06 95.5883 775.759 94.8758 774.294 96.0973C772.461 97.6241 771.545 101.441 768.95 102.51C766.873 103.365 763.911 102.866 762.69 102.51C768.644 106.632 772.003 104.953 774.294 104.953C776.584 104.953 776.278 101.441 777.347 101.441C778.202 101.441 778.823 101.848 779.027 102.052C779.739 101.696 781.5 101.288 782.844 102.51C784.523 104.037 791.547 104.8 795.669 104.953C798.967 105.075 800.809 102.357 801.318 100.983C800.402 102.052 798.265 101.441 795.669 101.441C793.074 101.441 784.829 96.0973 782.844 95.4865Z",
    fill: "#686666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.277 44.425C791.75 45.1884 791.903 47.4786 789.918 49.1581C789.177 49.9215 772.207 50.5323 766.71 54.96C761.214 59.3878 764.115 79.2365 763.046 78.4731C761.977 77.7097 763.198 62.1361 764.115 56.6396C765.031 51.143 770.069 45.9518 770.527 44.425C770.985 42.8982 782.589 40.1499 788.238 39.2338C792.758 38.5009 796.941 41.8803 798.468 43.6616C797.247 43.6616 794.498 43.8142 793.277 44.425Z",
    fill: "#0B0F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.013 44.425C797.622 44.1426 793.277 44.425 793.277 49.1581C798.315 52.5171 798.315 54.6547 799.69 54.96C801.064 55.2654 803.303 55.0103 804.372 55.9264C805.441 56.8425 802.54 63.7132 804.372 64.6293C806.204 65.5454 804.474 66.0034 805.746 71.6527C806.088 73.1717 807.35 82.7135 808.189 80.8136C808.952 79.0839 814.602 73.3322 817.044 77.4546C817.334 77.9436 820.302 67.6327 818.011 66.1059C815.721 64.579 814.602 54.7049 813.227 53.0254C811.853 51.3459 810.784 45.2386 801.013 44.425Z",
    fill: "#0B0F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.212 120.134C814.55 116.775 812.922 109.873 811.7 109.141C810.173 108.224 805.898 115.401 803.761 116.011C801.623 116.622 798.875 118.912 798.111 120.134C797.348 121.355 791.393 125.936 787.576 125.63C785.056 125.429 787.563 132.633 789.946 138.16C787.982 134.025 785.048 128.562 782.691 126.394C778.874 122.882 778.263 121.202 777.805 122.119C777.347 123.035 776.431 127.462 777.805 130.821C779.179 134.18 786.508 148.991 790.325 148.838C793.378 148.716 808.189 129.651 815.212 120.134Z",
    fill: "#E8E0D4",
    stroke: "#E8E0D4",
    strokeWidth: 0.165017
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.365 114.484C852.143 124.867 901.831 187.35 888.063 183.686L861.655 183.686L755.943 198.379C743.396 200.728 735.915 207.94 735.6 198.379C735.231 187.193 749.52 163.897 755.943 155.721C758.647 152.28 772.308 137.234 772.919 133.57C773.408 130.638 776.584 126.546 778.11 124.867C777.5 127.157 784.218 141.204 793.531 137.234C802.845 133.264 813.141 113.857 815.365 114.484Z",
    fill: "#0B0F21"
  }))), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.5 213.204C1015.5 234.731 1010.41 254.05 1002.36 267.866C994.255 281.769 983.577 289.5 972.5 289.5C961.423 289.5 950.745 281.769 942.644 267.866C934.592 254.05 929.5 234.731 929.5 213.204C929.5 191.676 934.592 172.358 942.644 158.542C950.745 144.638 961.423 136.908 972.5 136.908C983.577 136.908 994.255 144.638 1002.36 158.542C1010.41 172.358 1015.5 191.676 1015.5 213.204Z",
    fill: "#7577A5",
    stroke: "#2A2C51",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3713_15982",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 934,
    y: 140,
    width: 77,
    height: 144
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 972.5,
    cy: 212.056,
    rx: 38.463,
    ry: 71.7593,
    fill: "#D38337",
    fillOpacity: 0.3
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3713_15982)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 913.37,
    y: 205.558,
    width: 117.111,
    height: 8.03704,
    transform: "rotate(-24.2173 913.37 205.558)",
    fill: "#A4A5CC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.606,
    y: 221.186,
    width: 117.111,
    height: 2.86387,
    transform: "rotate(-24.2173 915.606 221.186)",
    fill: "#A4A5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986 203.701C985.494 203.339 984.933 203.039 984.322 202.813C981.671 201.835 978.814 202.54 976.908 204.389C976.238 203.654 975.388 203.066 974.393 202.699C972.106 201.855 969.65 202.4 967.937 203.908C967.417 203.425 966.795 203.035 966.09 202.775C964.063 202.027 961.881 202.546 960.401 203.932C960.482 203.543 960.592 203.157 960.731 202.777C962.781 197.162 970.438 194.822 977.832 197.551C981.384 198.862 984.229 201.103 986 203.701Z",
    fill: "#242B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986 203.701C985.494 203.339 984.933 203.039 984.322 202.813C981.671 201.835 978.814 202.54 976.908 204.389C976.238 203.654 975.388 203.066 974.393 202.699C972.106 201.855 969.65 202.4 967.937 203.908C967.417 203.425 966.795 203.035 966.09 202.775C964.063 202.027 961.881 202.546 960.401 203.932C960.482 203.543 960.592 203.157 960.731 202.777C962.781 197.162 970.438 194.822 977.832 197.551C981.384 198.862 984.229 201.103 986 203.701Z",
    fill: "#242B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937 190.501C937.618 190.442 938.254 190.464 938.895 190.576C941.677 191.061 943.8 193.108 944.531 195.667C945.477 195.368 946.506 195.286 947.55 195.468C949.95 195.886 951.807 197.593 952.54 199.76C953.231 199.604 953.963 199.578 954.703 199.707C956.831 200.079 958.462 201.625 959.054 203.57C959.178 203.192 959.275 202.802 959.343 202.403C960.361 196.51 954.893 190.634 947.132 189.281C943.404 188.63 939.826 189.141 937 190.501Z",
    fill: "#242B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.911 201.417C965.129 201.044 965.302 200.633 965.419 200.191C966.079 197.715 964.758 195.208 962.468 194.591C960.178 193.974 957.787 195.481 957.127 197.957C957.009 198.399 956.954 198.842 956.957 199.274L956.882 199.254L957.018 201.531C957.229 205.066 961.795 206.296 963.736 203.34L964.986 201.437L964.911 201.417Z",
    fill: "#242B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.943 195.968C960.405 195.332 960.614 194.483 960.452 193.611C960.291 192.739 959.792 192.023 959.134 191.596C958.673 192.233 958.464 193.081 958.626 193.953C958.787 194.825 959.285 195.541 959.943 195.968Z",
    fill: "#242B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.44 196.91C963.357 196.127 963.598 195.287 964.171 194.613C964.745 193.939 965.532 193.57 966.315 193.531C966.398 194.314 966.157 195.153 965.583 195.827C965.01 196.501 964.222 196.871 963.44 196.91Z",
    fill: "#242B4B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.051,
    y: 259.075,
    width: 117.111,
    height: 17.952,
    transform: "rotate(-24.2173 919.051 259.075)",
    fill: "#A4A5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.305 226.268C999.948 225.414 1000.76 223.438 1000.62 221.175C1001.56 221.941 1002.41 222.981 1003.05 224.233C1003.45 225.003 1003.73 225.792 1003.91 226.567L1008.04 242.791C1008.35 243.992 1006.83 244.779 1006.04 243.832L995.396 231.148C994.832 230.529 994.325 229.803 993.906 228.985C993.264 227.733 992.915 226.433 992.841 225.217C994.593 226.642 996.663 227.121 998.305 226.268Z",
    fill: "#242B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.65 213.566C1021.65 213.566 1020.06 213.747 1019.33 214.129C1018.59 214.51 1014.81 215.239 1015.85 220.048C1014.86 220.048 1014.1 220.022 1013.16 220.51C1011 221.632 1009.75 222.643 1010.27 227.57C1008.97 226.151 1007.94 226.685 1007.28 227.031C1005.36 228.026 1004.54 230.651 1004.55 232.686C1004.32 232.362 1004.11 232.02 1003.93 231.659C1001.2 226.337 1004.65 219.08 1011.64 215.451C1014.99 213.708 1018.55 213.119 1021.65 213.566Z",
    fill: "#242B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.526 238.048C974.526 238.048 975.593 236.849 976.327 236.468C977.061 236.086 979.845 233.401 983.131 237.048C983.704 236.236 984.127 235.592 985.067 235.104C987.226 233.982 988.77 233.541 992.455 236.825C992.06 234.937 993.087 234.403 993.754 234.057C995.669 233.062 998.273 233.904 999.91 235.097C999.782 234.721 999.625 234.351 999.44 233.991C996.713 228.669 988.838 227.296 981.852 230.925C978.497 232.668 975.957 235.248 974.526 238.048Z",
    fill: "#242B4B"
  }))), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.31 224.268C1007.95 223.414 1008.76 221.438 1008.62 219.175C1009.56 219.941 1010.41 220.98 1011.05 222.233C1011.45 223.003 1011.73 223.792 1011.91 224.567L1016.04 240.791C1016.35 241.992 1014.83 242.779 1014.04 241.832L1003.4 229.148C1002.83 228.529 1002.33 227.803 1001.91 226.985C1001.26 225.733 1000.92 224.433 1000.84 223.217C1002.59 224.642 1004.66 225.121 1006.31 224.268Z",
    fill: "#0B0F21"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.65 211.566C1029.65 211.566 1028.06 211.747 1027.33 212.128C1026.59 212.51 1022.81 213.239 1023.85 218.048C1022.86 218.048 1022.1 218.022 1021.16 218.51C1019 219.632 1017.75 220.643 1018.27 225.57C1016.97 224.151 1015.94 224.685 1015.28 225.031C1013.36 226.026 1012.54 228.651 1012.55 230.686C1012.32 230.362 1012.11 230.019 1011.93 229.659C1009.2 224.337 1012.65 217.08 1019.64 213.451C1022.99 211.708 1026.55 211.119 1029.65 211.566Z",
    fill: "#0B0F21"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M982.526 236.048C982.526 236.048 983.593 234.849 984.327 234.467C985.061 234.086 987.845 231.401 991.131 235.048C991.704 234.236 992.127 233.592 993.067 233.104C995.226 231.982 996.77 231.541 1000.46 234.825C1000.06 232.937 1001.09 232.403 1001.75 232.057C1003.67 231.062 1006.27 231.904 1007.91 233.097C1007.78 232.721 1007.63 232.351 1007.44 231.991C1004.71 226.668 996.838 225.296 989.852 228.925C986.497 230.668 983.957 233.248 982.526 236.048Z",
    fill: "#0B0F21"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M1013 191.701C1012.49 191.339 1011.93 191.038 1011.32 190.813C1008.67 189.835 1005.81 190.54 1003.91 192.389C1003.24 191.654 1002.39 191.066 1001.39 190.699C999.106 189.855 996.65 190.4 994.937 191.908C994.417 191.425 993.795 191.035 993.09 190.775C991.063 190.027 988.881 190.546 987.401 191.932C987.482 191.543 987.592 191.157 987.731 190.777C989.781 185.161 997.438 182.822 1004.83 185.551C1008.38 186.861 1011.23 189.103 1013 191.701Z",
    fill: "#0B0F21"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M1013 191.701C1012.49 191.339 1011.93 191.038 1011.32 190.813C1008.67 189.835 1005.81 190.54 1003.91 192.389C1003.24 191.654 1002.39 191.066 1001.39 190.699C999.106 189.855 996.65 190.4 994.937 191.908C994.417 191.425 993.795 191.035 993.09 190.775C991.063 190.027 988.881 190.546 987.401 191.932C987.482 191.543 987.592 191.157 987.731 190.777C989.781 185.161 997.438 182.822 1004.83 185.551C1008.38 186.861 1011.23 189.103 1013 191.701Z",
    fill: "#0B0F21"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M964 178.501C964.618 178.442 965.254 178.464 965.895 178.576C968.677 179.061 970.8 181.108 971.531 183.667C972.477 183.368 973.506 183.286 974.55 183.468C976.95 183.886 978.807 185.593 979.54 187.76C980.231 187.603 980.963 187.578 981.703 187.707C983.831 188.078 985.462 189.625 986.054 191.57C986.178 191.191 986.275 190.802 986.343 190.403C987.361 184.509 981.893 178.634 974.132 177.28C970.404 176.63 966.826 177.141 964 178.501Z",
    fill: "#0B0F21"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M991.911 189.417C992.129 189.044 992.302 188.633 992.419 188.191C993.079 185.715 991.758 183.207 989.468 182.591C987.178 181.974 984.787 183.481 984.127 185.957C984.009 186.399 983.954 186.841 983.957 187.274L983.882 187.254L984.018 189.53C984.229 193.066 988.795 194.296 990.736 191.34L991.986 189.437L991.911 189.417Z",
    fill: "#0B0F21"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M986.943 183.968C987.405 183.332 987.614 182.483 987.452 181.611C987.291 180.739 986.792 180.023 986.134 179.596C985.673 180.233 985.464 181.081 985.626 181.953C985.787 182.825 986.285 183.541 986.943 183.968Z",
    fill: "#0B0F21"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M990.44 184.91C990.357 184.127 990.598 183.287 991.171 182.613C991.745 181.939 992.532 181.57 993.315 181.53C993.398 182.314 993.157 183.153 992.583 183.827C992.01 184.501 991.222 184.871 990.44 184.91Z",
    fill: "#0B0F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3713_15982",
    x: 406.678,
    y: 66.258,
    width: 16.9107,
    height: 14.2343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.50318
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.751592
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3713_15982"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3713_15982",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3713_15982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHaunted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Haunted.76e1645a3d5d93282577a56ad56049d9.svg";